<template>
  <div class="block">
    <div class="block">
      <div style="display: flex; align-items: center; justify-content: center;">
        <el-tag style="margin-right: 10px;">选择账户：</el-tag>
        <el-cascader v-model="userUalue" :options="options1" filterable style="margin-right: 10px;"></el-cascader>
        <el-select v-model="cleanForm.hdname" placeholder="请选择区域" clearable style="width: 200px">
          <el-option label="浙江" value="浙江" />
          <el-option label="福建" value="福建" />
        </el-select>
      </div>



    </div>
    <el-button @click="edit" v-if="dingshi" type="primary" size="small">投放日期调整(计划id)</el-button>
    <el-button @click="handleClick" type="primary" size="small">设置时段(计划id)</el-button>
    <el-button @click="yusuanonchange" type="primary" size="small">修改出价(计划id)</el-button>
    <el-button @click="editDx = true" type="primary" size="small">修改定向(计划id)</el-button>
    <el-button @click="riyusonchangge" type="primary" size="small">修改日预算(计划id)</el-button>
    <el-button @click="offPlan" type="primary" size="small">关停计划(计划id)</el-button>
    <el-button @click="onPlan" type="primary" size="small">开启计划(计划id)</el-button>
    <el-button @click="offGround" type="primary" size="small">关停广告组(广告组id)</el-button>
    <el-button @click="onGround" type="primary" size="small">开启广告组(广告组id)</el-button>
    <el-button @click="delPlan" type="danger" size="small">删除计划(计划id)</el-button>
    <!--    <el-button @click="ces"  type="danger" size="small">测试按钮</el-button>-->
    <el-row>
      <el-col :span="12">
        <div class="grid-content bg-purple">
          <el-input
            type="textarea"
            autosize
            placeholder="输入账户名"
            v-model="textarea1">
          </el-input>
        </div>
      </el-col>
      <el-col :span="12">
        <div class="grid-content bg-purple-light">
          <el-input
            type="textarea"
            autosize
            placeholder="请输入计划id或广告组id或全部"
            v-model="textarea2">
          </el-input>
        </div>
      </el-col>
    </el-row>
    <el-dialog title="修改投放时段" width="500px" :visible.sync="dialog">
      <el-row :gutter="20">
        <el-col :span="12" style="width: 150px">
          <el-time-select
            style="width: 150px"
            v-model="startTime"
            :picker-options ="WkpickerOptions"
            placeholder="开始时间"
            @change="validateAndGenerateTimeSet"
          ></el-time-select>
        </el-col>
        <el-col :span="12" style="width: 150px">
          <el-time-select
            style="width: 150px"
            v-model="endTime"
            :picker-options="WkpickerOptions"
            placeholder="结束时间"
            @change="validateAndGenerateTimeSet"
          ></el-time-select>
        </el-col>
      </el-row>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialog = false">取 消</el-button>
        <el-button type="primary" @click="updateEd(form)">确 定</el-button>
      </div>
    </el-dialog>
    <el-dialog title="修改开启时间" :visible.sync="dialog1">

      <el-tabs v-model="activeName1" @tab-click="boo" type="border-card">
        <el-tab-pane name="first" label="长期投放">
          <span class="demonstration">开启日期</span>
          <el-date-picker
            v-model="value3"
            type="date"
            align="right"
            value-format="yyyy-MM-dd"
            placeholder="选择日期">
          </el-date-picker>
        </el-tab-pane>
        <el-tab-pane name="second" label="指定开始和结束日期">
          <el-date-picker
            v-model="value1"
            type="daterange"
            align="right"
            unlink-panels
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            value-format="yyyy-MM-dd"
            :picker-options="pickerOptions"
            @change="chooseTimeRange">
          </el-date-picker>
        </el-tab-pane>

      </el-tabs>

      <div slot="footer" class="dialog-footer">
        <el-button @click="dialog1 = false">取 消</el-button>
        <el-button type="primary" @click="updateTime(form)">确 定</el-button>
      </div>
    </el-dialog>


    <el-dialog title="修改出价" :visible.sync="yusuandialog">

      <div>
        <el-button @click="decrementPercentage">减少(%)</el-button>
        <el-button @click="incrementPercentage">增加(%)</el-button>
        <el-input v-model="inputValue" class="input-box"></el-input>
        <el-button @click="decrement">减少(元)</el-button>
        <el-button @click="increment">增加(元)</el-button>
        <!--        <el-input-->
        <!--          style = 'color: red'-->
        <!--          placeholder="请输入内容"-->
        <!--          v-model="tishiValue"-->
        <!--          :disabled="true">-->
        <!--        </el-input>-->
        <el-tag v-model="tishiValue" type="danger">{{ tishiValue }}</el-tag>
      </div>

      <div slot="footer" class="dialog-footer">
        <el-button @click="yusuandialog = false">取 消</el-button>
        <el-button type="primary" @click="revbud">确 定</el-button>
      </div>
    </el-dialog>


    <el-dialog title="修改定向" :visible.sync="editDx">

      <div>
        <el-form label-position="right" :model="formLabelAlign1">

          <el-form-item label="性别:">
            <el-radio-group v-model="sex">
              <el-radio-button label="男"></el-radio-button>
              <el-radio-button label="女"></el-radio-button>
              <el-radio-button label="不限"></el-radio-button>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="年龄(不选即不限):">
            <div>
              <el-checkbox-group v-model="age">
                <el-checkbox-button v-for="(item,i) in ages" :label="item.id" :key="i">{{ item.value }}
                </el-checkbox-button>
              </el-checkbox-group>
            </div>
          </el-form-item>
        </el-form>
      </div>

      <div slot="footer" class="dialog-footer">
        <el-button @click="editDx = false">取 消</el-button>
        <el-button type="primary" @click="dxEdit">确 定</el-button>
      </div>
    </el-dialog>

    <el-dialog title="修改日预算" :visible.sync="riyusdialog">

      <div>
        修改日预算(不限为-1)：
        <el-input v-model="riyusanvalue" class="input-box"></el-input>
        元
      </div>

      <div slot="footer" class="dialog-footer">
        <el-button @click="riyusdialog = false">取 消</el-button>
        <el-button type="primary" @click="edDailyBudget">确 定</el-button>
      </div>
    </el-dialog>


  </div>


</template>

<style scoped>
.input-box {
  width: 100px; /* 设置输入框宽度 */
}
</style>

<script>
import FileSaver from 'file-saver';
import XLSX from 'xlsx';
import {excel} from '../until/excel';
import axios from "axios";

export default {
  data() {
    const c1 = [{
      id: 25,
      value: '0-17岁'
    },
      {
        id: 26,
        value: '18-24岁'
      },
      {
        id: 27,
        value: '25-29岁'
      },
      {
        id: 28,
        value: '30-39岁'
      },
      {
        id: 29,
        value: '40-49岁'
      },
      {
        id: 30,
        value: '50岁及以上'
      },
    ]
    return {

      startTime: '',   // 开始时间
      endTime: '',     // 结束时间
      timeSet: '',     // 当日二进制时间段表示
      weeklyTimeSet: '', // 一周的时间段组合字符串
      WkpickerOptions: {
        start: '00:00',
        step: '00:30',
        end: '24:00',
      },
      weeklyTimeArray: Array(7).fill('0'.repeat(48)), // 初始化一周的时间段
      formLabelAlign1: {},
      sex: '不限',
      sex1: [],
      age: [],
      sexList: [],

      ageIdList: [],
      ages: c1,
      age2: [],
      editDx: false,
      riyusanvalue: 0,
      riyusdialog: false,
      groupids: '',
      tishiValue: '',
      yusType: '',
      inputValue: 0,
      yusprice: 0,
      textarea1: '',
      textarea2: '',
      planids: [],
      adid: [],
      dialog3: false,
      offer: false,
      form: {},
      xiane: true,
      activeName: 'first',
      activeName3: 'first',
      activeName1: 'first',
      value3: '',
      dialog1: false,
      dialog: false,
      dialog2: false,
      yusuandialog: false,
      valueFlag: 0,
      flag: 0,
      userUalue: '',
      isDisable: false,
      options1: [
        {
          value: 'xiaobai',
          label: '行长',
          children: [
            //   {
            //   value: 'mrqy',
            //   label: '河马阅读',
            // },
            {
              value: 'fjlldk',
              label: '福建流量端口',
            },
            {
              value: 'zhiyue',
              label: '智跃',
            },
            {
              value: 'xzs3',
              label: '新追书3',
            },


            {
              value: 'chaungyou',
              label: '创游',
            },
            {
              value: 'yuyong',
              label: '誉拥',
            },
            {
              value: 'ezht',
              label: '二组鸿图',
            },
            {
              value: 'djh',
              label: '短剧汇',
            },
            {
              value: 'ezfy3',
              label: '二组飞鱼3',
            },

            {
              value: 'shushen',
              label: '数升',
            },
            {
              value: 'sdjl',
              label: '闪电精灵',
            },

            {
              value: 'lingmao',
              label: '灵猫',
            },
            {
              value: 'fyzm3',
              label: '飞鱼zhuimeng3',
            },
            {
              value: 'gglys',
              label: '滚滚养生',
            },
            {
              value: 'yygl',
              label: '悠游果林',
            },
            {
              value: 'pslxtt',
              label: 'psl血糖贴',
            },
            {
              value: 'sumon',
              label: '速盟',
            },
            {
              value: 'aicz',
              label: '艾草枕',
            },
            {
              value: 'llxs',
              label: '零零小说',
            },
            {
              value: 'ygyd',
              label: '阳光阅读',
            },
            {
              value: 'ezjd',
              label: '二组金袋',
            },
            {
              value: 'fjdj',
              label: '福建帝江',
            },
            {
              value: 'sls',
              label: '赛诺思',
            },
            {
              value: 'shouhen',
              label: '守恒',
            },
            {
              value: 'hqdd',
              label: '惠券多多',
            },
            {
              value: 'fmcp',
              label: '肥猫测评',
            },
            {
              value: 'ydd',
              label: '喻点点',
            },


            {
              value: 'fy3',
              label: '飞鱼3',
            },
            {
              value: 'mgdj',
              label: '芒果短剧',
            },
            {
              value: 'fjfy',
              label: '福建飞鱼',
            },

            {
              value: 'zjfy',
              label: '浙江飞鱼',
            },

            {
              value: 'qlyss',
              label: '麒麟养生书',
            },
            {
              value: 'mfxx',
              label: '满芳小说',
            },
            {
              value: 'hdsw',
              label: '绘读书屋',
            },
            {
              value: 'malilian',
              label: '码力连',
            },
            {
              value: 'xinlm',
              label: '新蓝莓',
            },
            {
              value: 'yiping',
              label: '一品',
            },
            {
              value: 'yipingbj',
              label: '一品别家',
            },
            {
              value: 'momao',
              label: '魔猫',
            },


            {
              value: 'djpsl',
              label: '帝江psl',
            },
            {
              value: 'smdk3',
              label: '生米端口3',
            },
            {
              value: 'qdxgj',
              label: '千堆雪工具',
            },
            {
              value: 'xmll',
              label: '芎猫来了',
            },
            {
              value: 'mxjc',
              label: '梦享剧场',
            }, {
              value: 'fydj',
              label: '飞鱼短剧',
            },
            {
              value: 'taotie',
              label: '饕餮',
            },
            {
              value: 'zhuyun',
              label: '诸云',
            },
            {
              value: 'fjzy',
              label: '福建诸云',
            },
            {
              value: 'zssq',
              label: '追书神器',
            },
            {
              value: 'zssqx',
              label: '追书神器（新）',
            },
            {
              value: 'hdswx',
              label: '绘读书屋（新）',
            },
            {
              value: 'xinzssq',
              label: '追书神器新端口（psl）',
            },
            {
              value: 'hdpsl',
              label: '绘读福建端口（psl）',
            },
            {
              value: 'lmxs',
              label: '蓝莓小说',
            },
            // {
            //   value: 'qinmu',
            //   label: '青木',
            // },
            {
              value: 'misu',
              label: '米速',
            },
            {
              value: 'ysxs',
              label: '云尚小说',
            },
            {
              value: 'ggyd',
              label: '呱呱阅读',
            },
            {
              value: 'mdjc',
              label: '魔豆剧场',
            },
            {
              value: 'fmxs',
              label: '肥猫小说',
            },
            // {
            //   value:'qexs',
            //   label: '企鹅小说',
            // },
            {
              value: 'dzff',
              label: '点众付费',
            }, {
              value: 'qkdj',
              label: '趣看短剧',
            },
            {
              value: 'qdxs',
              label: '趣点小说',
            }, {
              value: 'smxs',
              label: '生米小说',
            },

            {
              value: 'smxsxin',
              label: '生米小说新端口',
            }
            , {
              value: 'htxs',
              label: '胡桃小说',
            }, {
              value: 'fhxs',
              label: '繁花小说',
            }, {
              value: 'nyyxs',
              label: '念有云小说',
            },
            // {
            //   value: 'klxs',
            //   label: '考拉小说',
            // },
            // {
            //   value: 'ssxs',
            //   label: '松鼠小说',
            // },
            {
              value: 'hmxs',
              label: '火苗小说',
            },
            // {
            //   value: 'fjyk',
            //   label: '福建伊看',
            // },
            {
              value: 'aicp',
              label: '爱测评',
            },


          ]
        },
      ],
      options: [{
        value: 'DAY',
        label: '按天汇总'
      }, {
        value: 'HOUR',
        label: '按小时汇总'
      }, {
        value: 'SUMMARY',
        label: '汇总'
      }
      ],
      value: '',
      level: [{
        value: 'ACCOUNT',
        label: '账户层级'
      }, {
        value: 'CAMPAIGN',
        label: '计划层级'
      }, {
        value: 'GROUP',
        label: '广告组层级'
      },
        {
          value: 'ADVERTISEMENT',
          label: '广告层级'
        },
        {
          value: 'CREATIVE',
          label: '创意层级'
        }],
      /*
      小邱
       */
      xiaobai: [
        '6dc95a3defa9966711cd4722521bd7c9cf0d4ea90655e8f07bdbf2f50a263955',
        'aa68c17f59c80f9f64924fbc737329e74213fd1deefd8bd4a7277b5b053dbff6',
        '34e86c1ff5d892d596ee71e5af2127aa44e8abbd1dd2d15b62007263c14d84a1',
        'a4bc5a9f3ea89a29682ea6f4f7fbe1fc280e28a941312bce21dfdf423f700ccc',
        '96583eebdfe6abc8d6d7f60770a419d6ce850eecb4ddd94de95a0915851c7cb2',
        'b2021802e714197beb33b9814a07ba782863f12dc5025dc9198201c8fe41fb42',
        'ed73be9ea82f902a57eb33d4e9b3507c90310acc6d8a5aa5bd3ba0307f97ab73',
        'e1cbaed0ca7ff3042e521fb04dd1a113f8fdf5ff803b0477c93f70842a1aa477',
        '860aa0e3a31f05262240fac510e10b75953f87eac68f4fb8580d59edb7c09b60',
        'e8e8039b11fd3d9512539df44c8d394aed413e0ddffd0ade107ef0217de5aa37',
        'f585de648d1cd31eea439748b13243b9a69919ad63c13680370db0381215c0ff',
        '4744587d6c61bec8ac9be5b9f33b093bc0a87a2bb53ea30fc31ec5786f272326',
        '303485872e860966a38e658526494792c0d8c1a4f7d9e966243614a64c3eea88',
        '0fb4afee15f7be9f1721fdd7542a7f0e4f64fca5c42eddc50b570cb60ca3c6b1',
        '19160b355d135f2bf81d75507b278702281919d130c1b6b6cc08ea6c5b1862be',
        'e2d4aa4a79122fe3577bf8d3f272e2b4c7229c5baf205bff544046c9805f0383',
        'b1e521335e7125379475bfec5e8919d4e5fae0e775ab81ba9bd3db5baaa9982a',
        'f76d300cfd4867d959037d4bf72b0742a4db0304a0ccebbd56fd1a51302a03cb',
        'fb3fb44e273848a4213601661e831f4be7410344f0a2418330c74869d2dd5fc8',
        'f544da7436c27b900b721daaa95511699ef17688d26fad186396657c61fd6a59',
        '0229ae7e5d6f227f13fb5a072c31ab1f4c8c803adc5957cb6610beef16dd3456',
        '39b54d6240940fc365bd89fca85889b130dad5b36948a3a9deeebf30d4145b28',
        '6a6075d085291f45aafdfe28509eebef09f305990ef6382686d8759758e2b878',
        '4ba2ddde978aee132088eada19057b58458ef60ea3ef4e9ab18dace489721360',
        '16d3db04663f1e08fd81f1e78e9363e768c4fb5a71588f7cc9e9bd345d1828e3',
        '23699a954607fda6d763e7ef8f6bbd2c393e55c5e419c3d665251c0f4d89844b',
        '10e3c6659799ca1d0b6c9e650eb2bc0fd7fd909c0a0251bb4e42ed4c313074f8',
        'c6b9e6001061d8553c97585d89db6a73bd994baa0cf9910856df722c9030e4ac',
        'a695e00c563db29da9948f0f1ec91b1f88fa4dd9905073834b855503d698bc8d',
        '9ea3b2c8be2d3f1eaf1fe10abd8472ee93694800de78f6452a5183262a156e5a',
        'd822ad1012a19acfaf257523c9039d1776947197404881abf4a3578b66781dc7',
        '486f4b28e581115a8553250038402b292903557a244437c935469cfb3b801c85',
        'b2d7a62ed4af20b121b852e78770651f279fba51e76abf1cfb79949f59a96ad5',
        'a9fe63db512952f354d0ca6e0a3d7a907040f2b97c3d7ffd378256affffa0fce',
        'd134a2a222f534574d06d611ab495f2c9c983180e995e621277f5f142924062b',
        'a563a4dba2e2169000f7d481264bed47456a2327bd02a4a497b94bbc7ad7dd2d',
        '13eed7622b2ef6453ecb67b916f8902bbbd94eae33e2a6f547311e9d35af37ea',
        'f16167d0ab97b0e7d0de06676948e7a69617b1fda488d68d5c0b5cd29009d227',
        'e16a91a501abbbfbff42085a7e7ef87c26e2a625a0ed57bd47ac2cccecde3fc6',
        'e7880ba449204c377bcd50f41442b6bdf6476824e502f31a74dd6c32f1ee1219',
        '4506f258f3e97e9bbc0e6a4689b41f35036e046b671827474122ee1a8aac1d14',
        '4df4b81fee3917bb3bc75bb6243093a98a8b5e9fd2e4c2ba1a83ee8e08ad8149',
        '5c39ae4a47b7caf659105f1e20b9c9333e64fd232b69159c3586121b470fb67c',
        '16df9372f715630db7f5bfa48b4fc45f12efd26246f0bed4a34faca221326d25',
        '2c6788bf7c41822a9b3f33ac8fe7690d7216c9959a7e7a17995b716be38f2de0',
        '37a5d3d52846de748458624df8ae36da3f295a5c65d6503552cc88d6ff65744a',
        '9d186f52232c21355e43305160c36c13725240eab970c4704ec3a39d892f246c',
        '647ff5323cc51ebcaf19c0da63c08243ea62bac9e66160152dff67ee6151e327',
        '37a5d3d52846de748458624df8ae36da3f295a5c65d6503552cc88d6ff65744a',
        '1c5a12e4d9a364b46b0ba1098deed90988d3f3b3609cd08513769dd76d488aed',
        '624dd3f28f200582892f903fc57ab391e3c8657df3c771d4cdc50a0b158c25de',
        '1386a5b387b949dcbc13b0ae892841500869e2ec4c670c97283b20b38c27cc62',
        'cbd83741443704b8a2e0a3882082b8fa80f11cabfd48e6cb3659481d8914c237',
        'd6c0436fdddac059d4c2d18c054107d18604b7f47a9c6f78e27d5f76fafad4f9',
        '83bfc0a1badf8e7d889c1661d732a66f48d9e79f8e702c8e76f23d1ca7003e2f',
        '8005f1dd40320829ef258b305054888670fdfb50691e6979a1c24a017ef18fce',
        '5fa781af2057afc1c2c8326af26df990b23c07c823d216f8cebcaf3b962d3a4d',
        '32cba8db68ac41feebe465d797c63859aa7c44882dbb2b3f543212b84d27cf97',
        'b6514d0ce5b16d4e5921da0ea07e17af3674d8c336565655fa71d558ebec5632',
        '4e1bc20e909c0af15d3af689c94454625f86ce807213294a7d32f6f203d87d97',
        '79a85abb4d69870358431ea6893501d4e84cf6d0667fa2e07560c51b178db658',
        'f87bc2bccb56871e74648586d2f357d18d00e4ba0dd16d836a90b318b0ff7c0b',
        '3fb67e77472639dda30f2ba3800db9077042c54db6a5fc4cb13c0dc44b934ea6',
        '18b5c9a4e07c69011c89cb5900de10b18943e8ece0b74d55604fc11cf59925be',
        '9f579140714bf84f57caabdb350fed3191a9ea780958027859b7fe639c4499af',
        'a2d4109aada4787b5a5dc9acc77307e56a9ec8b3a1adef93f35e74f29f25bbb3',
        '12a7e5e0e2efd4387a7f23fd310a395bc9f0aa4f05d609d62baa85f3bdc99e90',
        'b09048704760726c49b0737693e087e198c187bedf034eb0ab34c782287fb688',
        'b2c1ed96440ce56a8f61b36d208b3205e94ca2cf761439527fdeb78aa83a3950',
        '83f3986b3ad057267f91feb3c2e8a76658b2bb4faf8f5a331accdd01349964c5',
        'c474b4daa8c3f04208cb165b1601d647a837142d342e297b36e999899595492a',
        'ba6275f424434a54044427ee49870f50eb6917b8422d25f18e57ef58376893b2',
        '85965ee4c18522506e98e4d023c355fba5cca4eaabd09af1c265bc4fb3744779',
        '61844a44256a845b70712210e9ca53df3d408e05c2cdff371776e3bdf82ad6f9',
        '64604a34cd87a105b51e51dd85c2423d56a0733b63e8587b35b92b5102e3cb94',
        '5dd2f064df1f680f5d6da27b739519596c95d6f933df1e3736c727a5ea817a3c'



      ],

      cleanForm: {
        hdname: '',
        source: 'custom',
        customUuids: '',
        cltime: ''
      },
      //数据
      dingshi: true,
      values: '',
      pickerOptions: {
        shortcuts: [{
          text: '最近一周',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近一个月',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近三个月',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
            picker.$emit('pick', [start, end]);
          }
        }]
      },
      time: '',
      value1: '',
      value2: '',
      datas: [],
      datadata: [],
      temp: [],
      temp1: [],
      temp2: [],
      temp3: [],

      startDate: '20220701',
      endDate: '20220710',
      namedata: [],
      datanums: [
        {
          nuMshowCount: 0,
          nuMclickCount: 0,
          nuMspent: 0,
          nuMformsubmitCount: 0,
          nuMdisGeneralBalance: 0,
          nuMbalance: 0,
          nuMcustomPayCount: 0,
          nuMreactivation: 0,
          nuMcustomRetainCount: 0
        }
      ],
      qiliangcode: 0,
      sks: '',
      list: [],
      money: 200,
      money2: 0.5,
      money3: 0.0,
      moneys: 0.0,
      max: 0,
      ctrJson: [{
        nameid: '',
        CTR: 0,
        CVR: 0,
        CLR: 0,
        but: 0,
        zdycl: 0,
        zdyff: 0,
        zdylh: 0

      }],
      playCode: [],
      Newswicth: [],
      map: new Map,
      groudId: [],
      kaiguan: 0,
      adids: '',
      numtest: [],
      planid: [],
      groudId1: [],
      groupiddddd: '',
      AllIds: []
    }
  },
  methods: {

    validateAndGenerateTimeSet() {
      if (this.startTime && this.endTime) {
        const startHour = parseInt(this.startTime.split(':')[0]);
        const startMinute = parseInt(this.startTime.split(':')[1]);
        const endHour = parseInt(this.endTime.split(':')[0]);
        const endMinute = parseInt(this.endTime.split(':')[1]);

        // 计算起始和结束的索引
        const startIndex = (startHour * 2) + (startMinute === 30 ? 1 : 0);
        const endIndex = (endHour * 2) + (endMinute === 30 ? 1 : 0);

        // 生成时间段的二进制表示
        let binaryTimeSet = '0'.repeat(48).split('');
        for (let i = startIndex; i < endIndex; i++) {
          binaryTimeSet[i] = '1';
        }
        this.timeSet = binaryTimeSet.join('');

        // 直接应用到整周
        this.applyToWholeWeek();
      }
    },
    // 应用到一周的每一天
    applyToWholeWeek() {
      if (this.timeSet) {
        this.weeklyTimeArray = Array(7).fill(this.timeSet); // 将当前的timeSet应用到每一天
        this.updateWeeklyTimeSet();
      }
    },
    // 更新一周时间段的字符串表示
    updateWeeklyTimeSet() {
      this.weeklyTimeSet = this.weeklyTimeArray.join('');
    },
    async dxEdit() {

      if (this.userUalue[1] === "mrqy") {
        this.sks = this.xiaobai[0]
      } else if (this.userUalue[1] === "qexs") {
        this.sks = this.xiaobai[1]
      } else if (this.userUalue[1] === "fhxs") {
        this.sks = this.xiaobai[3]
      } else if (this.userUalue[1] === "klxs") {
        this.sks = this.xiaobai[4]
      } else if (this.userUalue[1] === "ssxs") {
        this.sks = this.xiaobai[5]
      } else if (this.userUalue[1] === "hmxs") {
        this.sks = this.xiaobai[6]
      } else if (this.userUalue[1] === "htxs") {
        this.sks = this.xiaobai[7]
      } else if (this.userUalue[1] === "fjyk") {
        this.sks = this.xiaobai[8]
      } else if (this.userUalue[1] === "smxs") {
        this.sks = this.xiaobai[9]
      } else if (this.userUalue[1] === "qkdj") {
        this.sks = this.xiaobai[10]
      } else if (this.userUalue[1] === "nyyxs") {
        this.sks = this.xiaobai[49]
      } else if (this.userUalue[1] === "aicp") {
        this.sks = this.xiaobai[12]
      } else if (this.userUalue[1] === "xsdq") {
        this.sks = this.xiaobai[13]
      } else if (this.userUalue[1] === "qdxs") {
        this.sks = this.xiaobai[14]
      } else if (this.userUalue[1] === "ysxs") {
        this.sks = this.xiaobai[15]
      } else if (this.userUalue[1] === "ggyd") {
        this.sks = this.xiaobai[16]
      } else if (this.userUalue[1] === "fmxs") {
        this.sks = this.xiaobai[17]
      } else if (this.userUalue[1] === "mdjc") {
        this.sks = this.xiaobai[18]
      } else if (this.userUalue[1] === "lmxs") {
        this.sks = this.xiaobai[19]
      } else if (this.userUalue[1] === "qinmu") {
        this.sks = this.xiaobai[20]
      } else if (this.userUalue[1] === "misu") {
        this.sks = this.xiaobai[21]
      } else if (this.userUalue[1] === "mxjc") {
        this.sks = this.xiaobai[22]
      } else if (this.userUalue[1] === "zssq") {
        this.sks = this.xiaobai[23]
      } else if (this.userUalue[1] === "fydj") {
        this.sks = this.xiaobai[24]
      } else if (this.userUalue[1] === "taotie") {
        this.sks = this.xiaobai[25]
      } else if (this.userUalue[1] === "hdsw") {
        this.sks = this.xiaobai[26]
      } else if (this.userUalue[1] === "xinzssq") {
        this.sks = this.xiaobai[27]
      } else if (this.userUalue[1] === "zhuyun") {
        this.sks = this.xiaobai[28]
      } else if (this.userUalue[1] === "zssqx") {
        this.sks = this.xiaobai[29]
      } else if (this.userUalue[1] === "hdswx") {
        this.sks = this.xiaobai[30]
      } else if (this.userUalue[1] === "xinlm") {
        this.sks = this.xiaobai[31]
      } else if (this.userUalue[1] === "hdpsl") {
        this.sks = this.xiaobai[32]
      } else if (this.userUalue[1] === "smxsxin") {
        this.sks = this.xiaobai[33]
      } else if (this.userUalue[1] === "djpsl") {
        this.sks = this.xiaobai[34]
      } else if (this.userUalue[1] === "qdxgj") {
        this.sks = this.xiaobai[35]
      } else if (this.userUalue[1] === "xmll") {
        this.sks = this.xiaobai[36]
      } else if (this.userUalue[1] === "smdk3") {
        this.sks = this.xiaobai[37]
      } else if (this.userUalue[1] === "yiping") {
        this.sks = this.xiaobai[38]
      } else if (this.userUalue[1] === "momao") {
        this.sks = this.xiaobai[39]
      } else if (this.userUalue[1] === "yipingbj") {
        this.sks = this.xiaobai[40]
      } else if (this.userUalue[1] === "malilian") {
        this.sks = this.xiaobai[41]
      } else if (this.userUalue[1] === "qlyss") {
        this.sks = this.xiaobai[42]
      } else if (this.userUalue[1] === "mfxx") {
        this.sks = this.xiaobai[43]
      } else if (this.userUalue[1] === "zjfy") {
        this.sks = this.xiaobai[44]
      } else if (this.userUalue[1] === "fjfy") {
        this.sks = this.xiaobai[45]
      } else if (this.userUalue[1] === "ydd") {
        this.sks = this.xiaobai[46]
      } else if (this.userUalue[1] === "mgdj") {
        this.sks = this.xiaobai[47]
      } else if (this.userUalue[1] === "fy3") {
        this.sks = this.xiaobai[48]
      } else if (this.userUalue[1] === "shouhen") {
        this.sks = this.xiaobai[50]
      } else if (this.userUalue[1] === "fmcp") {
        this.sks = this.xiaobai[51]
      } else if (this.userUalue[1] === "hqdd") {
        this.sks = this.xiaobai[52]
      } else if (this.userUalue[1] === "sls") {
        this.sks = this.xiaobai[53]
      } else if (this.userUalue[1] === "llxs") {
        this.sks = this.xiaobai[54]
      } else if (this.userUalue[1] === "fjdj") {
        this.sks = this.xiaobai[55]
      } else if (this.userUalue[1] === "ygyd") {
        this.sks = this.xiaobai[56]
      } else if (this.userUalue[1] === "ezjd") {
        this.sks = this.xiaobai[57]
      }else if (this.userUalue[1] === "sumon") {
        this.sks = this.xiaobai[58]
      }
      else if (this.userUalue[1] === "aicz") {
        this.sks = this.xiaobai[59]
      }
      else if (this.userUalue[1] === "gglys") {
        this.sks = this.xiaobai[60]
      }
      else if (this.userUalue[1] === "pslxtt") {
        this.sks = this.xiaobai[61]
      }
      else if (this.userUalue[1] === "yygl") {
        this.sks = this.xiaobai[62]
      }
      else if (this.userUalue[1] === "fyzm3") {
        this.sks = this.xiaobai[63]
      }
      else if (this.userUalue[1] === "djh") {
        this.sks = this.xiaobai[64]
      }
      else if (this.userUalue[1] === "ezfy3") {
        this.sks = this.xiaobai[65]
      }
      else if (this.userUalue[1] === "fjzy") {
        this.sks = this.xiaobai[66]
      }
      else if (this.userUalue[1] === "lingmao") {
        this.sks = this.xiaobai[67]
      }
      else if (this.userUalue[1] === "sdjl") {
        this.sks = this.xiaobai[68]
      }
      else if (this.userUalue[1] === "shushen") {
        this.sks = this.xiaobai[69]
      }
      else if (this.userUalue[1] === "ezht") {
        this.sks = this.xiaobai[70]
      }
      else if (this.userUalue[1] === "chaungyou") {
        this.sks = this.xiaobai[71]
      }
      else if (this.userUalue[1] === "yuyong") {
        this.sks = this.xiaobai[72]
      }

      else if (this.userUalue[1] === "zhiyue") {
        this.sks = this.xiaobai[73]
      }
      else if (this.userUalue[1] === "xzs3") {
        this.sks = this.xiaobai[74]
      }
      else if (this.userUalue[1] === "fjlldk") {
        this.sks = this.xiaobai[75]
      }

      this.planids = this.textarea2.trim().split(/\n/);
      this.adid = await  this.confimuuid(this.textarea1)

      this.sexList = [];
      if (this.sex === "女") {
        this.sex1 = [20]
      } else if (this.sex === "男") {
        this.sex1 = [19]
      }

      if (this.age.length === 0) {
        this.age2 = [25, 26, 27, 28, 29, 30]
      } else {

        this.age2 = this.age.join(",")

      }
      if (this.planids == "全部") {
        for (let keys in this.adid) {
          let parms = {
            token: this.sks,
            adid: this.adid[keys],
            startAndStop: 1
          }
          let time = parseInt(new Date().getTime()) + '';
          let nonce = Math.round(Math.random() * 100000000000)

          try {
            let res = await this.$axios.post('api/openapi/v1/ad/campaign/pageInfoByLastId?access_token=' + parms.token + '&timestamp=' + time + '&nonce=' + nonce + '&advertiser_id=' + parms.adid, {
              "lastId": 0,
              "deleted": 0,
              "pageSize": 100
            });

            for (let item of res.data.data.data) {
              let parms = {
                //危险
                token: this.sks,
                adid: this.adid[keys],
                campaignId: item.id,
              }
              await this.revdingxiang(parms);
            }
          } catch (error) {
            console.error(error);
          }
        }
      } else {
        for (let keys in this.planids) {
          let parms = {
            //危险
            token: this.sks,
            adid: this.adid[keys],
            campaignId: this.planids[keys],
          }
          await this.revdingxiang(parms);
        }
      }


      console.log(this.age)
      console.log(this.sex)
      this.editDx = false
    },


    async updateEd() {
      if (this.planids == "全部") {
        const processPlan = async (scheduleTimeTemplate) => {
          for (let keys in this.adid) {
            let parms = {
              token: this.sks,
              adid: this.adid[keys],
              startAndStop: 1
            }
            let time = parseInt(new Date().getTime()) + '';
            let nonce = Math.round(Math.random() * 100000000000)

            try {
              let res = await this.$axios.post('api/openapi/v1/ad/campaign/pageInfoByLastId?access_token=' + parms.token + '&timestamp=' + time + '&nonce=' + nonce + '&advertiser_id=' + parms.adid, {
                "lastId": 0,
                "deleted": 0,
                "pageSize": 100
              });

              for (let item of res.data.data.data) {
                this.groudId = [];
                let pams = {
                  token: this.sks,
                  adid: this.adid[keys],
                  campaignId: item.id
                };
                this.adids = this.adid[keys];
                await this.PostGroup3(pams);

                for (let a = 0; a < this.groudId.length; a++) {
                  let parm = {
                    token: this.sks,
                    adid: this.adids,
                    ids: this.groudId[a],
                    scheduleTime: scheduleTimeTemplate
                  };
                  await this.PostGroupTime(parm);
                }
              }
            } catch (error) {
              console.error(error);
            }
          }
        };
        if (this.weeklyTimeSet != '') {
          await processPlan(this.weeklyTimeSet)
        } else {
          this.$message.error('请先选择时间')
        }


      } else {
        for (let keys in this.planids) {
          this.groudId = []
          let pams = {
            //危险
            token: this.sks,
            adid: this.adid[keys],
            campaignId: this.planids[keys]
          }
          this.adids = this.adid[keys]
          await this.PostGroup3(pams)
          for (let a = 0; a < this.groudId.length; a++) {
            let parm = {
              token: this.sks,
              adid: this.adids,
              ids: this.groudId[a],
              scheduleTime: this.weeklyTimeSet
            }
            await this.PostGroupTime(parm)
          }
        }

      }


    },
    async delPlan() {
      if (this.userUalue[1] === "mrqy") {
        this.sks = this.xiaobai[0]
      } else if (this.userUalue[1] === "qexs") {
        this.sks = this.xiaobai[1]
      } else if (this.userUalue[1] === "fhxs") {
        this.sks = this.xiaobai[3]
      } else if (this.userUalue[1] === "klxs") {
        this.sks = this.xiaobai[4]
      } else if (this.userUalue[1] === "ssxs") {
        this.sks = this.xiaobai[5]
      } else if (this.userUalue[1] === "hmxs") {
        this.sks = this.xiaobai[6]
      } else if (this.userUalue[1] === "htxs") {
        this.sks = this.xiaobai[7]
      } else if (this.userUalue[1] === "fjyk") {
        this.sks = this.xiaobai[8]
      } else if (this.userUalue[1] === "smxs") {
        this.sks = this.xiaobai[9]
      } else if (this.userUalue[1] === "qkdj") {
        this.sks = this.xiaobai[10]
      } else if (this.userUalue[1] === "nyyxs") {
        this.sks = this.xiaobai[49]
      } else if (this.userUalue[1] === "aicp") {
        this.sks = this.xiaobai[12]
      } else if (this.userUalue[1] === "xsdq") {
        this.sks = this.xiaobai[13]
      } else if (this.userUalue[1] === "qdxs") {
        this.sks = this.xiaobai[14]
      } else if (this.userUalue[1] === "ysxs") {
        this.sks = this.xiaobai[15]
      } else if (this.userUalue[1] === "ggyd") {
        this.sks = this.xiaobai[16]
      } else if (this.userUalue[1] === "fmxs") {
        this.sks = this.xiaobai[17]
      } else if (this.userUalue[1] === "mdjc") {
        this.sks = this.xiaobai[18]
      } else if (this.userUalue[1] === "lmxs") {
        this.sks = this.xiaobai[19]
      } else if (this.userUalue[1] === "qinmu") {
        this.sks = this.xiaobai[20]
      } else if (this.userUalue[1] === "misu") {
        this.sks = this.xiaobai[21]
      } else if (this.userUalue[1] === "mxjc") {
        this.sks = this.xiaobai[22]
      } else if (this.userUalue[1] === "zssq") {
        this.sks = this.xiaobai[23]
      } else if (this.userUalue[1] === "fydj") {
        this.sks = this.xiaobai[24]
      } else if (this.userUalue[1] === "taotie") {
        this.sks = this.xiaobai[25]
      } else if (this.userUalue[1] === "hdsw") {
        this.sks = this.xiaobai[26]
      } else if (this.userUalue[1] === "xinzssq") {
        this.sks = this.xiaobai[27]
      } else if (this.userUalue[1] === "zhuyun") {
        this.sks = this.xiaobai[28]
      } else if (this.userUalue[1] === "zssqx") {
        this.sks = this.xiaobai[29]
      } else if (this.userUalue[1] === "hdswx") {
        this.sks = this.xiaobai[30]
      } else if (this.userUalue[1] === "xinlm") {
        this.sks = this.xiaobai[31]
      } else if (this.userUalue[1] === "hdpsl") {
        this.sks = this.xiaobai[32]
      } else if (this.userUalue[1] === "smxsxin") {
        this.sks = this.xiaobai[33]
      } else if (this.userUalue[1] === "djpsl") {
        this.sks = this.xiaobai[34]
      } else if (this.userUalue[1] === "qdxgj") {
        this.sks = this.xiaobai[35]
      } else if (this.userUalue[1] === "xmll") {
        this.sks = this.xiaobai[36]
      } else if (this.userUalue[1] === "smdk3") {
        this.sks = this.xiaobai[37]
      } else if (this.userUalue[1] === "yiping") {
        this.sks = this.xiaobai[38]
      } else if (this.userUalue[1] === "momao") {
        this.sks = this.xiaobai[39]
      } else if (this.userUalue[1] === "yipingbj") {
        this.sks = this.xiaobai[40]
      } else if (this.userUalue[1] === "malilian") {
        this.sks = this.xiaobai[41]
      } else if (this.userUalue[1] === "qlyss") {
        this.sks = this.xiaobai[42]
      } else if (this.userUalue[1] === "mfxx") {
        this.sks = this.xiaobai[43]
      } else if (this.userUalue[1] === "zjfy") {
        this.sks = this.xiaobai[44]
      } else if (this.userUalue[1] === "fjfy") {
        this.sks = this.xiaobai[45]
      } else if (this.userUalue[1] === "ydd") {
        this.sks = this.xiaobai[46]
      } else if (this.userUalue[1] === "mgdj") {
        this.sks = this.xiaobai[47]
      } else if (this.userUalue[1] === "fy3") {
        this.sks = this.xiaobai[48]
      } else if (this.userUalue[1] === "shouhen") {
        this.sks = this.xiaobai[50]
      } else if (this.userUalue[1] === "fmcp") {
        this.sks = this.xiaobai[51]
      } else if (this.userUalue[1] === "hqdd") {
        this.sks = this.xiaobai[52]
      } else if (this.userUalue[1] === "sls") {
        this.sks = this.xiaobai[53]
      } else if (this.userUalue[1] === "llxs") {
        this.sks = this.xiaobai[54]
      } else if (this.userUalue[1] === "fjdj") {
        this.sks = this.xiaobai[55]
      } else if (this.userUalue[1] === "ygyd") {
        this.sks = this.xiaobai[56]
      } else if (this.userUalue[1] === "ezjd") {
        this.sks = this.xiaobai[57]
      }else if (this.userUalue[1] === "sumon") {
        this.sks = this.xiaobai[58]
      }   else if (this.userUalue[1] === "aicz") {
        this.sks = this.xiaobai[59]
      }
      else if (this.userUalue[1] === "gglys") {
        this.sks = this.xiaobai[60]
      }
      else if (this.userUalue[1] === "pslxtt") {
        this.sks = this.xiaobai[61]
      }
      else if (this.userUalue[1] === "yygl") {
        this.sks = this.xiaobai[62]
      }
      else if (this.userUalue[1] === "fyzm3") {
        this.sks = this.xiaobai[63]
      }
      else if (this.userUalue[1] === "djh") {
        this.sks = this.xiaobai[64]
      }
      else if (this.userUalue[1] === "ezfy3") {
        this.sks = this.xiaobai[65]
      }
      else if (this.userUalue[1] === "fjzy") {
        this.sks = this.xiaobai[66]
      }
      else if (this.userUalue[1] === "lingmao") {
        this.sks = this.xiaobai[67]
      }
      else if (this.userUalue[1] === "sdjl") {
        this.sks = this.xiaobai[68]
      }
      else if (this.userUalue[1] === "shushen") {
        this.sks = this.xiaobai[69]
      }
      else if (this.userUalue[1] === "ezht") {
        this.sks = this.xiaobai[70]
      }
      else if (this.userUalue[1] === "chaungyou") {
        this.sks = this.xiaobai[71]
      }
      else if (this.userUalue[1] === "yuyong") {
        this.sks = this.xiaobai[72]
      }
      else if (this.userUalue[1] === "zhiyue") {
        this.sks = this.xiaobai[73]
      }
      else if (this.userUalue[1] === "xzs3") {
        this.sks = this.xiaobai[74]
      }
      else if (this.userUalue[1] === "fjlldk") {
        this.sks = this.xiaobai[75]
      }
      this.planids = this.textarea2.trim().split(/\n/);
      // this.adid = this.textarea1.trim().split(/\n/);
      this.adid = await  this.confimuuid(this.textarea1)

      for (let keys in this.planids) {
        let parms = {
          //危险
          token: this.sks,
          adid: this.adid[keys],
          campaignId: this.planids[keys],
        }
        await this.delPlanId(parms);
      }
    },
    async offPlan() {
      if (this.userUalue[1] === "mrqy") {
        this.sks = this.xiaobai[0]
      } else if (this.userUalue[1] === "qexs") {
        this.sks = this.xiaobai[1]
      } else if (this.userUalue[1] === "fhxs") {
        this.sks = this.xiaobai[3]
      } else if (this.userUalue[1] === "klxs") {
        this.sks = this.xiaobai[4]
      } else if (this.userUalue[1] === "ssxs") {
        this.sks = this.xiaobai[5]
      } else if (this.userUalue[1] === "hmxs") {
        this.sks = this.xiaobai[6]
      } else if (this.userUalue[1] === "htxs") {
        this.sks = this.xiaobai[7]
      } else if (this.userUalue[1] === "fjyk") {
        this.sks = this.xiaobai[8]
      } else if (this.userUalue[1] === "smxs") {
        this.sks = this.xiaobai[9]
      } else if (this.userUalue[1] === "qkdj") {
        this.sks = this.xiaobai[10]
      } else if (this.userUalue[1] === "nyyxs") {
        this.sks = this.xiaobai[49]
      } else if (this.userUalue[1] === "aicp") {
        this.sks = this.xiaobai[12]
      } else if (this.userUalue[1] === "xsdq") {
        this.sks = this.xiaobai[13]
      } else if (this.userUalue[1] === "qdxs") {
        this.sks = this.xiaobai[14]
      } else if (this.userUalue[1] === "ysxs") {
        this.sks = this.xiaobai[15]
      } else if (this.userUalue[1] === "ggyd") {
        this.sks = this.xiaobai[16]
      } else if (this.userUalue[1] === "fmxs") {
        this.sks = this.xiaobai[17]
      } else if (this.userUalue[1] === "mdjc") {
        this.sks = this.xiaobai[18]
      } else if (this.userUalue[1] === "lmxs") {
        this.sks = this.xiaobai[19]
      } else if (this.userUalue[1] === "qinmu") {
        this.sks = this.xiaobai[20]
      } else if (this.userUalue[1] === "misu") {
        this.sks = this.xiaobai[21]
      } else if (this.userUalue[1] === "mxjc") {
        this.sks = this.xiaobai[22]
      } else if (this.userUalue[1] === "zssq") {
        this.sks = this.xiaobai[23]
      } else if (this.userUalue[1] === "fydj") {
        this.sks = this.xiaobai[24]
      } else if (this.userUalue[1] === "taotie") {
        this.sks = this.xiaobai[25]
      } else if (this.userUalue[1] === "hdsw") {
        this.sks = this.xiaobai[26]
      } else if (this.userUalue[1] === "xinzssq") {
        this.sks = this.xiaobai[27]
      } else if (this.userUalue[1] === "zhuyun") {
        this.sks = this.xiaobai[28]
      } else if (this.userUalue[1] === "zssqx") {
        this.sks = this.xiaobai[29]
      } else if (this.userUalue[1] === "hdswx") {
        this.sks = this.xiaobai[30]
      } else if (this.userUalue[1] === "xinlm") {
        this.sks = this.xiaobai[31]
      } else if (this.userUalue[1] === "hdpsl") {
        this.sks = this.xiaobai[32]
      } else if (this.userUalue[1] === "smxsxin") {
        this.sks = this.xiaobai[33]
      } else if (this.userUalue[1] === "djpsl") {
        this.sks = this.xiaobai[34]
      } else if (this.userUalue[1] === "qdxgj") {
        this.sks = this.xiaobai[35]
      } else if (this.userUalue[1] === "xmll") {
        this.sks = this.xiaobai[36]
      } else if (this.userUalue[1] === "smdk3") {
        this.sks = this.xiaobai[37]
      } else if (this.userUalue[1] === "yiping") {
        this.sks = this.xiaobai[38]
      } else if (this.userUalue[1] === "momao") {
        this.sks = this.xiaobai[39]
      } else if (this.userUalue[1] === "yipingbj") {
        this.sks = this.xiaobai[40]
      } else if (this.userUalue[1] === "malilian") {
        this.sks = this.xiaobai[41]
      } else if (this.userUalue[1] === "qlyss") {
        this.sks = this.xiaobai[42]
      } else if (this.userUalue[1] === "mfxx") {
        this.sks = this.xiaobai[43]
      } else if (this.userUalue[1] === "zjfy") {
        this.sks = this.xiaobai[44]
      } else if (this.userUalue[1] === "fjfy") {
        this.sks = this.xiaobai[45]
      } else if (this.userUalue[1] === "ydd") {
        this.sks = this.xiaobai[46]
      } else if (this.userUalue[1] === "mgdj") {
        this.sks = this.xiaobai[47]
      } else if (this.userUalue[1] === "fy3") {
        this.sks = this.xiaobai[48]
      } else if (this.userUalue[1] === "shouhen") {
        this.sks = this.xiaobai[50]
      } else if (this.userUalue[1] === "fmcp") {
        this.sks = this.xiaobai[51]
      } else if (this.userUalue[1] === "hqdd") {
        this.sks = this.xiaobai[52]
      } else if (this.userUalue[1] === "sls") {
        this.sks = this.xiaobai[53]
      } else if (this.userUalue[1] === "llxs") {
        this.sks = this.xiaobai[54]
      } else if (this.userUalue[1] === "fjdj") {
        this.sks = this.xiaobai[55]
      } else if (this.userUalue[1] === "ygyd") {
        this.sks = this.xiaobai[56]
      } else if (this.userUalue[1] === "ezjd") {
        this.sks = this.xiaobai[57]
      }else if (this.userUalue[1] === "sumon") {
        this.sks = this.xiaobai[58]
      }   else if (this.userUalue[1] === "aicz") {
        this.sks = this.xiaobai[59]
      }
      else if (this.userUalue[1] === "gglys") {
        this.sks = this.xiaobai[60]
      }
      else if (this.userUalue[1] === "pslxtt") {
        this.sks = this.xiaobai[61]
      }
      else if (this.userUalue[1] === "yygl") {
        this.sks = this.xiaobai[62]
      }
      else if (this.userUalue[1] === "fyzm3") {
        this.sks = this.xiaobai[63]
      }
      else if (this.userUalue[1] === "djh") {
        this.sks = this.xiaobai[64]
      }
      else if (this.userUalue[1] === "ezfy3") {
        this.sks = this.xiaobai[65]
      }
      else if (this.userUalue[1] === "fjzy") {
        this.sks = this.xiaobai[66]
      }
      else if (this.userUalue[1] === "lingmao") {
        this.sks = this.xiaobai[67]
      }
      else if (this.userUalue[1] === "sdjl") {
        this.sks = this.xiaobai[68]
      }
      else if (this.userUalue[1] === "shushen") {
        this.sks = this.xiaobai[69]
      }
      else if (this.userUalue[1] === "ezht") {
        this.sks = this.xiaobai[70]
      }
      else if (this.userUalue[1] === "chaungyou") {
        this.sks = this.xiaobai[71]
      }
      else if (this.userUalue[1] === "yuyong") {
        this.sks = this.xiaobai[72]
      }
      else if (this.userUalue[1] === "zhiyue") {
        this.sks = this.xiaobai[73]
      }
      else if (this.userUalue[1] === "xzs3") {
        this.sks = this.xiaobai[74]
      }
      else if (this.userUalue[1] === "fjlldk") {
        this.sks = this.xiaobai[75]
      }
      this.planids = this.textarea2.trim().split(/\n/);
      // this.adid = this.textarea1.trim().split(/\n/);
      this.adid = await  this.confimuuid(this.textarea1)

      if (this.planids == "全部") {
        for (let keys in this.adid) {
          let parms = {
            //危险
            token: this.sks,
            adid: this.adid[keys],
            startAndStop: 1
          }
          let time = parseInt(new Date().getTime()) + '';
          let nonce = Math.round(Math.random() * 100000000000)
          await this.$axios.post('api/openapi/v1/ad/campaign/pageInfoByLastId?access_token=' + parms.token + '&timestamp=' + time + '&nonce=' + nonce + '&advertiser_id=' + parms.adid, {
            "lastId": 0,
            "deleted": 0,
            "pageSize": 100
          }).then(res => {
            res.data.data.data.forEach(item => {

              let parms = {
                //危险
                token: this.sks,
                adid: this.adid[keys],
                campaignId: item.id,
                startAndStop: 1
              }
              this.offPlanId(parms);

            });
          })
        }


      } else {
        for (let keys in this.planids) {
          let parms = {
            //危险
            token: this.sks,
            adid: this.adid[keys],
            campaignId: this.planids[keys],
            startAndStop: 1
          }
          await this.offPlanId(parms);
        }
      }

    },

    async edbug(parms) {

      let time = parseInt(new Date().getTime()) + '';

      let nonce = Math.round(Math.random() * 100000000000)


      await this.$axios.post('api/openapi/v1/ad/group/pageInfo?access_token=' + parms.token + '&timestamp=' + time + '&nonce=' + nonce + '&advertiser_id=' + parms.adid, {
        "campaignId": parms.campaignId,
        "pageIndex": 1,
        "pageSize": 100,
      }).then(res => {


        this.groupids = res.data.data.list[0].id;
        let riyuss = this.riyusanvalue === '-1' ? this.riyusanvalue : this.riyusanvalue * 100000;

        let time = new Date().getTime() + ''; // 获取当前时间戳

        let nonce = Math.round(Math.random() * 100000000000); // 生成随机数

        let apiUrl = `api/openapi/v1/ad/group/batchEditDailyBudget?access_token=${parms.token}&timestamp=${time}&nonce=${nonce}&advertiser_id=${parms.adid}`;

        this.$axios.post(apiUrl, {
          ids: this.groupids,
          dailyBudget: riyuss
        }).then(res => {
          // 处理响应数据
        });

      })

    },
    async revdingxiang(parms) {

      let time = parseInt(new Date().getTime()) + '';

      let nonce = Math.round(Math.random() * 100000000000)


      await this.$axios.post('api/openapi/v1/ad/group/pageInfo?access_token=' + parms.token + '&timestamp=' + time + '&nonce=' + nonce + '&advertiser_id=' + parms.adid, {
        "campaignId": parms.campaignId,
        "pageIndex": 1,
        "pageSize": 100,
      }).then(res => {
        res.data.data.list.forEach(item => {
          console.log(item);

          let time1 = parseInt(new Date().getTime()) + '';

          let nonce2 = Math.round(Math.random() * 100000000000)


          this.$axios.post('api/openapi/v1/ad/group/editById?access_token=' + parms.token + '&timestamp=' + time1 + '&nonce=' + nonce2 + '&advertiser_id=' + parms.adid,
            {
              "id": item.id,
              "startDate": item.startDate,
              "endDate": item.endDate,
              "scheduleTime": item.scheduleTime,
              "name": item.name,
              "dailyBudget": item.dailyBudget,
              "spentType": item.spentType,
              "audienceInfo": {
                "sexList": this.sex1,
                "ageList": this.age2.split(',').map(Number),
              },


              "ocpxPrice": item.ocpxPrice,
              "industry1": item.industry1,
              "industry2": item.industry2
            }).then(resp => {
            console.log(resp)
            this.$message.success('修改成功')

          })
        });


      })

    },
    async revplanId(parms) {
      let time = parseInt(new Date().getTime()) + '';
      let nonce = Math.round(Math.random() * 100000000000)

      try {
        let res1 = await this.$axios.post('api/openapi/v1/ad/group/pageInfo?access_token=' + parms.token + '&timestamp=' + time + '&nonce=' + nonce + '&advertiser_id=' + parms.adid, {
          "campaignId": parms.campaignId,
          "pageIndex": 1,
          "pageSize": 100,
        });

        this.yusprice = res1.data.data.list[0].ocpxPrice;
        this.groupiddddd = res1.data.data.list.map(obj => obj.id).join(',');

        // 进行价格计算和修改
        if (this.yusType === '-') {
          if (this.inputValue > this.yusprice) {
            this.$message.warning("广告组" + this.groupiddddd + "减少的出价大于原来的价格了");
          } else {
            console.log("现在是-");
            this.yusprice -= this.inputValue * 100000;
          }
        } else if (this.yusType === '-%') {
          console.log("现在是-%");
          this.yusprice -= this.yusprice * this.inputValue * 0.01;
          this.yusprice = Math.floor(this.yusprice / 10000) * 10000;
        } else if (this.yusType === '+') {
          console.log("现在是+");
          this.yusprice += this.inputValue * 100000;
        } else if (this.yusType === '+%') {
          console.log("现在是+%");
          this.yusprice += this.yusprice * this.inputValue * 0.01;
          this.yusprice = Math.floor(this.yusprice / 10000) * 10000;
        } else {
          this.yusprice = this.inputValue * 100000;
        }

        let time2 = parseInt(new Date().getTime()) + '';
        let nonce2 = Math.round(Math.random() * 100000000000);

        console.log(this.yusprice);
        let res2 = await this.$axios.post('api/openapi/v1/ad/group/batchEditPrice?access_token=' + parms.token + '&timestamp=' + time2 + '&nonce=' + nonce2 + '&advertiser_id=' + parms.adid, {
          "ids": this.groupiddddd,
          "price": "500000",
          "ocpxPrice": this.yusprice
        });

        this.$message.success(this.groupiddddd + '修改成功');
        this.yusuandialog = false;

      } catch (error) {
        console.error(error);
      }
    }
    ,
    // 修改预算
    decrement() {

      this.yusType = '-';
      this.tishiValue = "现在你选择的是减少出价(元)"
    },
    decrementPercentage() {
      this.yusType = '-%'
      this.tishiValue = "现在你选择的是减少出价(%)"
    },
    increment() {
      this.yusType = '+'
      this.tishiValue = "现在你选择的是增加出价(元)"
    },
    incrementPercentage() {
      this.yusType = '+%'
      this.tishiValue = "现在你选择的是增加出价(%)"
    },
    yusuanonchange() {
      this.yusuandialog = true;
    },
    riyusonchangge() {
      this.riyusdialog = true;
    },
    async revbud() {

      if (this.userUalue[1] === "mrqy") {
        this.sks = this.xiaobai[0]
      } else if (this.userUalue[1] === "qexs") {
        this.sks = this.xiaobai[1]
      } else if (this.userUalue[1] === "fhxs") {
        this.sks = this.xiaobai[3]
      } else if (this.userUalue[1] === "klxs") {
        this.sks = this.xiaobai[4]
      } else if (this.userUalue[1] === "ssxs") {
        this.sks = this.xiaobai[5]
      } else if (this.userUalue[1] === "hmxs") {
        this.sks = this.xiaobai[6]
      } else if (this.userUalue[1] === "htxs") {
        this.sks = this.xiaobai[7]
      } else if (this.userUalue[1] === "fjyk") {
        this.sks = this.xiaobai[8]
      } else if (this.userUalue[1] === "smxs") {
        this.sks = this.xiaobai[9]
      } else if (this.userUalue[1] === "qkdj") {
        this.sks = this.xiaobai[10]
      } else if (this.userUalue[1] === "nyyxs") {
        this.sks = this.xiaobai[49]
      } else if (this.userUalue[1] === "aicp") {
        this.sks = this.xiaobai[12]
      } else if (this.userUalue[1] === "xsdq") {
        this.sks = this.xiaobai[13]
      } else if (this.userUalue[1] === "qdxs") {
        this.sks = this.xiaobai[14]
      } else if (this.userUalue[1] === "ysxs") {
        this.sks = this.xiaobai[15]
      } else if (this.userUalue[1] === "ggyd") {
        this.sks = this.xiaobai[16]
      } else if (this.userUalue[1] === "fmxs") {
        this.sks = this.xiaobai[17]
      } else if (this.userUalue[1] === "mdjc") {
        this.sks = this.xiaobai[18]
      } else if (this.userUalue[1] === "lmxs") {
        this.sks = this.xiaobai[19]
      } else if (this.userUalue[1] === "qinmu") {
        this.sks = this.xiaobai[20]
      } else if (this.userUalue[1] === "misu") {
        this.sks = this.xiaobai[21]
      } else if (this.userUalue[1] === "mxjc") {
        this.sks = this.xiaobai[22]
      } else if (this.userUalue[1] === "zssq") {
        this.sks = this.xiaobai[23]
      } else if (this.userUalue[1] === "fydj") {
        this.sks = this.xiaobai[24]
      } else if (this.userUalue[1] === "taotie") {
        this.sks = this.xiaobai[25]
      } else if (this.userUalue[1] === "hdsw") {
        this.sks = this.xiaobai[26]
      } else if (this.userUalue[1] === "xinzssq") {
        this.sks = this.xiaobai[27]
      } else if (this.userUalue[1] === "zhuyun") {
        this.sks = this.xiaobai[28]
      } else if (this.userUalue[1] === "zssqx") {
        this.sks = this.xiaobai[29]
      } else if (this.userUalue[1] === "hdswx") {
        this.sks = this.xiaobai[30]
      } else if (this.userUalue[1] === "xinlm") {
        this.sks = this.xiaobai[31]
      } else if (this.userUalue[1] === "hdpsl") {
        this.sks = this.xiaobai[32]
      } else if (this.userUalue[1] === "smxsxin") {
        this.sks = this.xiaobai[33]
      } else if (this.userUalue[1] === "djpsl") {
        this.sks = this.xiaobai[34]
      } else if (this.userUalue[1] === "qdxgj") {
        this.sks = this.xiaobai[35]
      } else if (this.userUalue[1] === "xmll") {
        this.sks = this.xiaobai[36]
      } else if (this.userUalue[1] === "smdk3") {
        this.sks = this.xiaobai[37]
      } else if (this.userUalue[1] === "yiping") {
        this.sks = this.xiaobai[38]
      } else if (this.userUalue[1] === "momao") {
        this.sks = this.xiaobai[39]
      } else if (this.userUalue[1] === "yipingbj") {
        this.sks = this.xiaobai[40]
      } else if (this.userUalue[1] === "malilian") {
        this.sks = this.xiaobai[41]
      } else if (this.userUalue[1] === "qlyss") {
        this.sks = this.xiaobai[42]
      } else if (this.userUalue[1] === "mfxx") {
        this.sks = this.xiaobai[43]
      } else if (this.userUalue[1] === "zjfy") {
        this.sks = this.xiaobai[44]
      } else if (this.userUalue[1] === "fjfy") {
        this.sks = this.xiaobai[45]
      } else if (this.userUalue[1] === "ydd") {
        this.sks = this.xiaobai[46]
      } else if (this.userUalue[1] === "mgdj") {
        this.sks = this.xiaobai[47]
      } else if (this.userUalue[1] === "fy3") {
        this.sks = this.xiaobai[48]
      } else if (this.userUalue[1] === "shouhen") {
        this.sks = this.xiaobai[50]
      } else if (this.userUalue[1] === "fmcp") {
        this.sks = this.xiaobai[51]
      } else if (this.userUalue[1] === "hqdd") {
        this.sks = this.xiaobai[52]
      } else if (this.userUalue[1] === "sls") {
        this.sks = this.xiaobai[53]
      } else if (this.userUalue[1] === "llxs") {
        this.sks = this.xiaobai[54]
      } else if (this.userUalue[1] === "fjdj") {
        this.sks = this.xiaobai[55]
      } else if (this.userUalue[1] === "ygyd") {
        this.sks = this.xiaobai[56]
      } else if (this.userUalue[1] === "ezjd") {
        this.sks = this.xiaobai[57]
      }else if (this.userUalue[1] === "sumon") {
        this.sks = this.xiaobai[58]
      }   else if (this.userUalue[1] === "aicz") {
        this.sks = this.xiaobai[59]
      }
      else if (this.userUalue[1] === "gglys") {
        this.sks = this.xiaobai[60]
      }
      else if (this.userUalue[1] === "pslxtt") {
        this.sks = this.xiaobai[61]
      }
      else if (this.userUalue[1] === "yygl") {
        this.sks = this.xiaobai[62]
      }
      else if (this.userUalue[1] === "fyzm3") {
        this.sks = this.xiaobai[63]
      }
      else if (this.userUalue[1] === "djh") {
        this.sks = this.xiaobai[64]
      }
      else if (this.userUalue[1] === "ezfy3") {
        this.sks = this.xiaobai[65]
      }
      else if (this.userUalue[1] === "fjzy") {
        this.sks = this.xiaobai[66]
      }
      else if (this.userUalue[1] === "lingmao") {
        this.sks = this.xiaobai[67]
      }
      else if (this.userUalue[1] === "sdjl") {
        this.sks = this.xiaobai[68]
      }
      else if (this.userUalue[1] === "shushen") {
        this.sks = this.xiaobai[69]
      }
      else if (this.userUalue[1] === "ezht") {
        this.sks = this.xiaobai[70]
      }
      else if (this.userUalue[1] === "chaungyou") {
        this.sks = this.xiaobai[71]
      }
      else if (this.userUalue[1] === "yuyong") {
        this.sks = this.xiaobai[72]
      }
      else if (this.userUalue[1] === "zhiyue") {
        this.sks = this.xiaobai[73]
      }
      else if (this.userUalue[1] === "xzs3") {
        this.sks = this.xiaobai[74]
      }
      else if (this.userUalue[1] === "fjlldk") {
        this.sks = this.xiaobai[75]
      }
      this.planids = this.textarea2.trim().split(/\n/);
      // this.adid = this.textarea1.trim().split(/\n/);
      this.adid = await  this.confimuuid(this.textarea1)


      if (this.planids == "全部") {

        for (let keys in this.adid) {

          let parms = {
            token: this.sks,
            adid: this.adid[keys],
            startAndStop: 1
          };
          let time = parseInt(new Date().getTime()) + '';
          let nonce = Math.round(Math.random() * 100000000000);

          try {
            // Fetch campaigns sequentially
            let res = await this.$axios.post('api/openapi/v1/ad/campaign/pageInfoByLastId?access_token=' + parms.token + '&timestamp=' + time + '&nonce=' + nonce + '&advertiser_id=' + parms.adid, {
              "lastId": 0,
              "deleted": 0,
              "pageSize": 100
            });

            for (let item of res.data.data.data) {
              let innerParms = {
                token: this.sks,
                adid: this.adid[keys],
                campaignId: item.id,
              };

              // Process each campaign one by one
              await this.revplanId(innerParms);
            }
          } catch (error) {
            console.error(`Error processing adid: ${this.adid[keys]}`, error);
          }
        }
      } else {

        for (let keys in this.planids) {
          let parms = {
            //危险
            token: this.sks,
            adid: this.adid[keys],
            campaignId: this.planids[keys],
          }
          await this.revplanId(parms);
        }
      }


    },

    async edDailyBudget() {

      if (this.userUalue[1] === "mrqy") {
        this.sks = this.xiaobai[0]
      } else if (this.userUalue[1] === "qexs") {
        this.sks = this.xiaobai[1]
      } else if (this.userUalue[1] === "fhxs") {
        this.sks = this.xiaobai[3]
      } else if (this.userUalue[1] === "klxs") {
        this.sks = this.xiaobai[4]
      } else if (this.userUalue[1] === "ssxs") {
        this.sks = this.xiaobai[5]
      } else if (this.userUalue[1] === "hmxs") {
        this.sks = this.xiaobai[6]
      } else if (this.userUalue[1] === "htxs") {
        this.sks = this.xiaobai[7]
      } else if (this.userUalue[1] === "fjyk") {
        this.sks = this.xiaobai[8]
      } else if (this.userUalue[1] === "smxs") {
        this.sks = this.xiaobai[9]
      } else if (this.userUalue[1] === "qkdj") {
        this.sks = this.xiaobai[10]
      } else if (this.userUalue[1] === "nyyxs") {
        this.sks = this.xiaobai[49]
      } else if (this.userUalue[1] === "aicp") {
        this.sks = this.xiaobai[12]
      } else if (this.userUalue[1] === "xsdq") {
        this.sks = this.xiaobai[13]
      } else if (this.userUalue[1] === "qdxs") {
        this.sks = this.xiaobai[14]
      } else if (this.userUalue[1] === "ysxs") {
        this.sks = this.xiaobai[15]
      } else if (this.userUalue[1] === "ggyd") {
        this.sks = this.xiaobai[16]
      } else if (this.userUalue[1] === "fmxs") {
        this.sks = this.xiaobai[17]
      } else if (this.userUalue[1] === "mdjc") {
        this.sks = this.xiaobai[18]
      } else if (this.userUalue[1] === "lmxs") {
        this.sks = this.xiaobai[19]
      } else if (this.userUalue[1] === "qinmu") {
        this.sks = this.xiaobai[20]
      } else if (this.userUalue[1] === "misu") {
        this.sks = this.xiaobai[21]
      } else if (this.userUalue[1] === "mxjc") {
        this.sks = this.xiaobai[22]
      } else if (this.userUalue[1] === "zssq") {
        this.sks = this.xiaobai[23]
      } else if (this.userUalue[1] === "fydj") {
        this.sks = this.xiaobai[24]
      } else if (this.userUalue[1] === "taotie") {
        this.sks = this.xiaobai[25]
      } else if (this.userUalue[1] === "hdsw") {
        this.sks = this.xiaobai[26]
      } else if (this.userUalue[1] === "xinzssq") {
        this.sks = this.xiaobai[27]
      } else if (this.userUalue[1] === "zhuyun") {
        this.sks = this.xiaobai[28]
      } else if (this.userUalue[1] === "zssqx") {
        this.sks = this.xiaobai[29]
      } else if (this.userUalue[1] === "hdswx") {
        this.sks = this.xiaobai[30]
      } else if (this.userUalue[1] === "xinlm") {
        this.sks = this.xiaobai[31]
      } else if (this.userUalue[1] === "hdpsl") {
        this.sks = this.xiaobai[32]
      } else if (this.userUalue[1] === "smxsxin") {
        this.sks = this.xiaobai[33]
      } else if (this.userUalue[1] === "djpsl") {
        this.sks = this.xiaobai[34]
      } else if (this.userUalue[1] === "qdxgj") {
        this.sks = this.xiaobai[35]
      } else if (this.userUalue[1] === "xmll") {
        this.sks = this.xiaobai[36]
      } else if (this.userUalue[1] === "smdk3") {
        this.sks = this.xiaobai[37]
      } else if (this.userUalue[1] === "yiping") {
        this.sks = this.xiaobai[38]
      } else if (this.userUalue[1] === "momao") {
        this.sks = this.xiaobai[39]
      } else if (this.userUalue[1] === "yipingbj") {
        this.sks = this.xiaobai[40]
      } else if (this.userUalue[1] === "malilian") {
        this.sks = this.xiaobai[41]
      } else if (this.userUalue[1] === "qlyss") {
        this.sks = this.xiaobai[42]
      } else if (this.userUalue[1] === "mfxx") {
        this.sks = this.xiaobai[43]
      } else if (this.userUalue[1] === "zjfy") {
        this.sks = this.xiaobai[44]
      } else if (this.userUalue[1] === "fjfy") {
        this.sks = this.xiaobai[45]
      } else if (this.userUalue[1] === "ydd") {
        this.sks = this.xiaobai[46]
      } else if (this.userUalue[1] === "mgdj") {
        this.sks = this.xiaobai[47]
      } else if (this.userUalue[1] === "fy3") {
        this.sks = this.xiaobai[48]
      } else if (this.userUalue[1] === "shouhen") {
        this.sks = this.xiaobai[50]
      } else if (this.userUalue[1] === "fmcp") {
        this.sks = this.xiaobai[51]
      } else if (this.userUalue[1] === "hqdd") {
        this.sks = this.xiaobai[52]
      } else if (this.userUalue[1] === "sls") {
        this.sks = this.xiaobai[53]
      } else if (this.userUalue[1] === "llxs") {
        this.sks = this.xiaobai[54]
      } else if (this.userUalue[1] === "fjdj") {
        this.sks = this.xiaobai[55]
      } else if (this.userUalue[1] === "ygyd") {
        this.sks = this.xiaobai[56]
      } else if (this.userUalue[1] === "ezjd") {
        this.sks = this.xiaobai[57]
      }else if (this.userUalue[1] === "sumon") {
        this.sks = this.xiaobai[58]
      }   else if (this.userUalue[1] === "aicz") {
        this.sks = this.xiaobai[59]
      }
      else if (this.userUalue[1] === "gglys") {
        this.sks = this.xiaobai[60]
      }
      else if (this.userUalue[1] === "pslxtt") {
        this.sks = this.xiaobai[61]
      }
      else if (this.userUalue[1] === "yygl") {
        this.sks = this.xiaobai[62]
      }
      else if (this.userUalue[1] === "fyzm3") {
        this.sks = this.xiaobai[63]
      }
      else if (this.userUalue[1] === "djh") {
        this.sks = this.xiaobai[64]
      }
      else if (this.userUalue[1] === "ezfy3") {
        this.sks = this.xiaobai[65]
      }
      else if (this.userUalue[1] === "fjzy") {
        this.sks = this.xiaobai[66]
      }
      else if (this.userUalue[1] === "lingmao") {
        this.sks = this.xiaobai[67]
      }
      else if (this.userUalue[1] === "sdjl") {
        this.sks = this.xiaobai[68]
      }
      else if (this.userUalue[1] === "shushen") {
        this.sks = this.xiaobai[69]
      }
      else if (this.userUalue[1] === "ezht") {
        this.sks = this.xiaobai[70]
      }
      else if (this.userUalue[1] === "chaungyou") {
        this.sks = this.xiaobai[71]
      }
      else if (this.userUalue[1] === "yuyong") {
        this.sks = this.xiaobai[72]
      }
      else if (this.userUalue[1] === "zhiyue") {
        this.sks = this.xiaobai[73]
      }
      else if (this.userUalue[1] === "xzs3") {
        this.sks = this.xiaobai[74]
      }
      else if (this.userUalue[1] === "fjlldk") {
        this.sks = this.xiaobai[75]
      }
      this.planids = this.textarea2.trim().split(/\n/);
      // this.adid = this.textarea1.trim().split(/\n/);
      this.adid = await  this.confimuuid(this.textarea1)

      if (this.planids == "全部") {

        for (let keys in this.adid) {
          let parms = {
            //危险
            token: this.sks,
            adid: this.adid[keys],
            startAndStop: 1
          }
          let time = parseInt(new Date().getTime()) + '';
          let nonce = Math.round(Math.random() * 100000000000)
          await this.$axios.post('api/openapi/v1/ad/campaign/pageInfoByLastId?access_token=' + parms.token + '&timestamp=' + time + '&nonce=' + nonce + '&advertiser_id=' + parms.adid, {
            "lastId": 0,
            "deleted": 0,
            "pageSize": 100
          }).then(res => {
            res.data.data.data.forEach(item => {
              let parms = {
                //危险
                token: this.sks,
                adid: this.adid[keys],
                campaignId: item.id,
              }
              this.edbug(parms);
            });
          })


          this.$message.success('修改日限额成功，日限额为：' + this.riyusanvalue)
          this.riyusdialog = false;
        }


      } else {
        for (let keys in this.planids) {
          let parms = {
            //危险
            token: this.sks,
            adid: this.adid[keys],
            campaignId: this.planids[keys],
          }
          await this.edbug(parms);
        }
        this.$message.success('修改日限额成功，日限额为：' + this.riyusanvalue)
        this.riyusdialog = false;
      }


    },
    async onPlan() {
      if (this.userUalue[1] === "mrqy") {
        this.sks = this.xiaobai[0]
      } else if (this.userUalue[1] === "qexs") {
        this.sks = this.xiaobai[1]
      } else if (this.userUalue[1] === "fhxs") {
        this.sks = this.xiaobai[3]
      } else if (this.userUalue[1] === "klxs") {
        this.sks = this.xiaobai[4]
      } else if (this.userUalue[1] === "ssxs") {
        this.sks = this.xiaobai[5]
      } else if (this.userUalue[1] === "hmxs") {
        this.sks = this.xiaobai[6]
      } else if (this.userUalue[1] === "htxs") {
        this.sks = this.xiaobai[7]
      } else if (this.userUalue[1] === "fjyk") {
        this.sks = this.xiaobai[8]
      } else if (this.userUalue[1] === "smxs") {
        this.sks = this.xiaobai[9]
      } else if (this.userUalue[1] === "qkdj") {
        this.sks = this.xiaobai[10]
      } else if (this.userUalue[1] === "nyyxs") {
        this.sks = this.xiaobai[49]
      } else if (this.userUalue[1] === "aicp") {
        this.sks = this.xiaobai[12]
      } else if (this.userUalue[1] === "xsdq") {
        this.sks = this.xiaobai[13]
      } else if (this.userUalue[1] === "qdxs") {
        this.sks = this.xiaobai[14]
      } else if (this.userUalue[1] === "ysxs") {
        this.sks = this.xiaobai[15]
      } else if (this.userUalue[1] === "ggyd") {
        this.sks = this.xiaobai[16]
      } else if (this.userUalue[1] === "fmxs") {
        this.sks = this.xiaobai[17]
      } else if (this.userUalue[1] === "mdjc") {
        this.sks = this.xiaobai[18]
      } else if (this.userUalue[1] === "lmxs") {
        this.sks = this.xiaobai[19]
      } else if (this.userUalue[1] === "qinmu") {
        this.sks = this.xiaobai[20]
      } else if (this.userUalue[1] === "misu") {
        this.sks = this.xiaobai[21]
      } else if (this.userUalue[1] === "mxjc") {
        this.sks = this.xiaobai[22]
      } else if (this.userUalue[1] === "zssq") {
        this.sks = this.xiaobai[23]
      } else if (this.userUalue[1] === "fydj") {
        this.sks = this.xiaobai[24]
      } else if (this.userUalue[1] === "taotie") {
        this.sks = this.xiaobai[25]
      } else if (this.userUalue[1] === "hdsw") {
        this.sks = this.xiaobai[26]
      } else if (this.userUalue[1] === "xinzssq") {
        this.sks = this.xiaobai[27]
      } else if (this.userUalue[1] === "zhuyun") {
        this.sks = this.xiaobai[28]
      } else if (this.userUalue[1] === "zssqx") {
        this.sks = this.xiaobai[29]
      } else if (this.userUalue[1] === "hdswx") {
        this.sks = this.xiaobai[30]
      } else if (this.userUalue[1] === "xinlm") {
        this.sks = this.xiaobai[31]
      } else if (this.userUalue[1] === "hdpsl") {
        this.sks = this.xiaobai[32]
      } else if (this.userUalue[1] === "smxsxin") {
        this.sks = this.xiaobai[33]
      } else if (this.userUalue[1] === "djpsl") {
        this.sks = this.xiaobai[34]
      } else if (this.userUalue[1] === "qdxgj") {
        this.sks = this.xiaobai[35]
      } else if (this.userUalue[1] === "xmll") {
        this.sks = this.xiaobai[36]
      } else if (this.userUalue[1] === "smdk3") {
        this.sks = this.xiaobai[37]
      } else if (this.userUalue[1] === "yiping") {
        this.sks = this.xiaobai[38]
      } else if (this.userUalue[1] === "momao") {
        this.sks = this.xiaobai[39]
      } else if (this.userUalue[1] === "yipingbj") {
        this.sks = this.xiaobai[40]
      } else if (this.userUalue[1] === "malilian") {
        this.sks = this.xiaobai[41]
      } else if (this.userUalue[1] === "qlyss") {
        this.sks = this.xiaobai[42]
      } else if (this.userUalue[1] === "mfxx") {
        this.sks = this.xiaobai[43]
      } else if (this.userUalue[1] === "zjfy") {
        this.sks = this.xiaobai[44]
      } else if (this.userUalue[1] === "fjfy") {
        this.sks = this.xiaobai[45]
      } else if (this.userUalue[1] === "ydd") {
        this.sks = this.xiaobai[46]
      } else if (this.userUalue[1] === "mgdj") {
        this.sks = this.xiaobai[47]
      } else if (this.userUalue[1] === "fy3") {
        this.sks = this.xiaobai[48]
      } else if (this.userUalue[1] === "shouhen") {
        this.sks = this.xiaobai[50]
      } else if (this.userUalue[1] === "fmcp") {
        this.sks = this.xiaobai[51]
      } else if (this.userUalue[1] === "hqdd") {
        this.sks = this.xiaobai[52]
      } else if (this.userUalue[1] === "sls") {
        this.sks = this.xiaobai[53]
      } else if (this.userUalue[1] === "llxs") {
        this.sks = this.xiaobai[54]
      } else if (this.userUalue[1] === "fjdj") {
        this.sks = this.xiaobai[55]
      } else if (this.userUalue[1] === "ygyd") {
        this.sks = this.xiaobai[56]
      } else if (this.userUalue[1] === "ezjd") {
        this.sks = this.xiaobai[57]
      }else if (this.userUalue[1] === "sumon") {
        this.sks = this.xiaobai[58]
      }   else if (this.userUalue[1] === "aicz") {
        this.sks = this.xiaobai[59]
      }
      else if (this.userUalue[1] === "gglys") {
        this.sks = this.xiaobai[60]
      }
      else if (this.userUalue[1] === "pslxtt") {
        this.sks = this.xiaobai[61]
      }
      else if (this.userUalue[1] === "yygl") {
        this.sks = this.xiaobai[62]
      }
      else if (this.userUalue[1] === "fyzm3") {
        this.sks = this.xiaobai[63]
      }
      else if (this.userUalue[1] === "djh") {
        this.sks = this.xiaobai[64]
      }
      else if (this.userUalue[1] === "ezfy3") {
        this.sks = this.xiaobai[65]
      }
      else if (this.userUalue[1] === "fjzy") {
        this.sks = this.xiaobai[66]
      }
      else if (this.userUalue[1] === "lingmao") {
        this.sks = this.xiaobai[67]
      }
      else if (this.userUalue[1] === "sdjl") {
        this.sks = this.xiaobai[68]
      }
      else if (this.userUalue[1] === "shushen") {
        this.sks = this.xiaobai[69]
      }
      else if (this.userUalue[1] === "ezht") {
        this.sks = this.xiaobai[70]
      }
      else if (this.userUalue[1] === "chaungyou") {
        this.sks = this.xiaobai[71]
      }
      else if (this.userUalue[1] === "yuyong") {
        this.sks = this.xiaobai[72]
      }
      else if (this.userUalue[1] === "zhiyue") {
        this.sks = this.xiaobai[73]
      }
      else if (this.userUalue[1] === "xzs3") {
        this.sks = this.xiaobai[74]
      }
      else if (this.userUalue[1] === "fjlldk") {
        this.sks = this.xiaobai[75]
      }
      this.planids = this.textarea2.trim().split(/\n/);
      // this.adid = this.textarea1.trim().split(/\n/);
      this.adid = await  this.confimuuid(this.textarea1)

      if (this.planids == "全部") {
        for (let keys in this.adid) {
          let parms = {
            //危险
            token: this.sks,
            adid: this.adid[keys],
            startAndStop: 1
          }
          let time = parseInt(new Date().getTime()) + '';
          let nonce = Math.round(Math.random() * 100000000000)
          await this.$axios.post('api/openapi/v1/ad/campaign/pageInfoByLastId?access_token=' + parms.token + '&timestamp=' + time + '&nonce=' + nonce + '&advertiser_id=' + parms.adid, {
            "lastId": 0,
            "deleted": 0,
            "pageSize": 100
          }).then(res => {
            res.data.data.data.forEach(item => {


              let parms = {
                //危险
                token: this.sks,
                adid: this.adid[keys],
                campaignId: item.id,
                startAndStop: 0
              }
              this.offPlanId(parms);


            });
          })
        }

      } else {
        for (let keys in this.planids) {
          let parms = {
            //危险
            token: this.sks,
            adid: this.adid[keys],
            campaignId: this.planids[keys],
            startAndStop: 0
          }
          await this.offPlanId(parms);
        }
      }


    },
    async offGround() {
      console.log(this.userUalue[1])
      if (this.userUalue[1] === "mrqy") {
        this.sks = this.xiaobai[0]
      } else if (this.userUalue[1] === "qexs") {
        this.sks = this.xiaobai[1]
      } else if (this.userUalue[1] === "fhxs") {
        this.sks = this.xiaobai[3]
      } else if (this.userUalue[1] === "klxs") {
        this.sks = this.xiaobai[4]
      } else if (this.userUalue[1] === "ssxs") {
        this.sks = this.xiaobai[5]
      } else if (this.userUalue[1] === "hmxs") {
        this.sks = this.xiaobai[6]
      } else if (this.userUalue[1] === "htxs") {
        this.sks = this.xiaobai[7]
      } else if (this.userUalue[1] === "fjyk") {
        this.sks = this.xiaobai[8]
      } else if (this.userUalue[1] === "smxs") {
        this.sks = this.xiaobai[9]
      } else if (this.userUalue[1] === "qkdj") {
        this.sks = this.xiaobai[10]
      } else if (this.userUalue[1] === "nyyxs") {
        this.sks = this.xiaobai[49]
      } else if (this.userUalue[1] === "aicp") {
        this.sks = this.xiaobai[12]
      } else if (this.userUalue[1] === "xsdq") {
        this.sks = this.xiaobai[13]
      } else if (this.userUalue[1] === "qdxs") {
        this.sks = this.xiaobai[14]
      } else if (this.userUalue[1] === "ysxs") {
        this.sks = this.xiaobai[15]
      } else if (this.userUalue[1] === "ggyd") {
        this.sks = this.xiaobai[16]
      } else if (this.userUalue[1] === "fmxs") {
        this.sks = this.xiaobai[17]
      } else if (this.userUalue[1] === "mdjc") {
        this.sks = this.xiaobai[18]
      } else if (this.userUalue[1] === "lmxs") {
        this.sks = this.xiaobai[19]
      } else if (this.userUalue[1] === "qinmu") {
        this.sks = this.xiaobai[20]
      } else if (this.userUalue[1] === "misu") {
        this.sks = this.xiaobai[21]
      } else if (this.userUalue[1] === "mxjc") {
        this.sks = this.xiaobai[22]
      } else if (this.userUalue[1] === "zssq") {
        this.sks = this.xiaobai[23]
      } else if (this.userUalue[1] === "fydj") {
        this.sks = this.xiaobai[24]
      } else if (this.userUalue[1] === "taotie") {
        this.sks = this.xiaobai[25]
      } else if (this.userUalue[1] === "hdsw") {
        this.sks = this.xiaobai[26]
      } else if (this.userUalue[1] === "xinzssq") {
        this.sks = this.xiaobai[27]
      } else if (this.userUalue[1] === "zhuyun") {
        this.sks = this.xiaobai[28]
      } else if (this.userUalue[1] === "zssqx") {
        this.sks = this.xiaobai[29]
      } else if (this.userUalue[1] === "hdswx") {
        this.sks = this.xiaobai[30]
      } else if (this.userUalue[1] === "xinlm") {
        this.sks = this.xiaobai[31]
      } else if (this.userUalue[1] === "hdpsl") {
        this.sks = this.xiaobai[32]
      } else if (this.userUalue[1] === "smxsxin") {
        this.sks = this.xiaobai[33]
      } else if (this.userUalue[1] === "djpsl") {
        this.sks = this.xiaobai[34]
      } else if (this.userUalue[1] === "qdxgj") {
        this.sks = this.xiaobai[35]
      } else if (this.userUalue[1] === "xmll") {
        this.sks = this.xiaobai[36]
      } else if (this.userUalue[1] === "smdk3") {
        this.sks = this.xiaobai[37]
      } else if (this.userUalue[1] === "yiping") {
        this.sks = this.xiaobai[38]
      } else if (this.userUalue[1] === "momao") {
        this.sks = this.xiaobai[39]
      } else if (this.userUalue[1] === "yipingbj") {
        this.sks = this.xiaobai[40]
      } else if (this.userUalue[1] === "malilian") {
        this.sks = this.xiaobai[41]
      } else if (this.userUalue[1] === "qlyss") {
        this.sks = this.xiaobai[42]
      } else if (this.userUalue[1] === "mfxx") {
        this.sks = this.xiaobai[43]
      } else if (this.userUalue[1] === "zjfy") {
        this.sks = this.xiaobai[44]
      } else if (this.userUalue[1] === "fjfy") {
        this.sks = this.xiaobai[45]
      } else if (this.userUalue[1] === "ydd") {
        this.sks = this.xiaobai[46]
      } else if (this.userUalue[1] === "mgdj") {
        this.sks = this.xiaobai[47]
      } else if (this.userUalue[1] === "fy3") {
        this.sks = this.xiaobai[48]
      } else if (this.userUalue[1] === "shouhen") {
        this.sks = this.xiaobai[50]
      } else if (this.userUalue[1] === "fmcp") {
        this.sks = this.xiaobai[51]
      } else if (this.userUalue[1] === "hqdd") {
        this.sks = this.xiaobai[52]
      } else if (this.userUalue[1] === "sls") {
        this.sks = this.xiaobai[53]
      } else if (this.userUalue[1] === "llxs") {
        this.sks = this.xiaobai[54]
      } else if (this.userUalue[1] === "fjdj") {
        this.sks = this.xiaobai[55]
      } else if (this.userUalue[1] === "ygyd") {
        this.sks = this.xiaobai[56]
      } else if (this.userUalue[1] === "ezjd") {
        this.sks = this.xiaobai[57]
      }else if (this.userUalue[1] === "sumon") {
        this.sks = this.xiaobai[58]
      }   else if (this.userUalue[1] === "aicz") {
        this.sks = this.xiaobai[59]
      }
      else if (this.userUalue[1] === "gglys") {
        this.sks = this.xiaobai[60]
      }
      else if (this.userUalue[1] === "pslxtt") {
        this.sks = this.xiaobai[61]
      }
      else if (this.userUalue[1] === "yygl") {
        this.sks = this.xiaobai[62]
      }
      else if (this.userUalue[1] === "fyzm3") {
        this.sks = this.xiaobai[63]
      }
      else if (this.userUalue[1] === "djh") {
        this.sks = this.xiaobai[64]
      }
      else if (this.userUalue[1] === "ezfy3") {
        this.sks = this.xiaobai[65]
      }
      else if (this.userUalue[1] === "fjzy") {
        this.sks = this.xiaobai[66]
      }
      else if (this.userUalue[1] === "lingmao") {
        this.sks = this.xiaobai[67]
      }
      else if (this.userUalue[1] === "sdjl") {
        this.sks = this.xiaobai[68]
      }
      else if (this.userUalue[1] === "shushen") {
        this.sks = this.xiaobai[69]
      }
      else if (this.userUalue[1] === "ezht") {
        this.sks = this.xiaobai[70]
      }
      else if (this.userUalue[1] === "chaungyou") {
        this.sks = this.xiaobai[71]
      }
      else if (this.userUalue[1] === "yuyong") {
        this.sks = this.xiaobai[72]
      }
      else if (this.userUalue[1] === "zhiyue") {
        this.sks = this.xiaobai[73]
      }
      else if (this.userUalue[1] === "xzs3") {
        this.sks = this.xiaobai[74]
      }
      else if (this.userUalue[1] === "fjlldk") {
        this.sks = this.xiaobai[75]
      }
      this.planids = this.textarea2.trim().split(/\n/);
      // this.adid = this.textarea1.trim().split(/\n/);
      this.adid = await  this.confimuuid(this.textarea1)

      if (this.planids == "全部") {
        for (let key in this.adid) {
          let adid = this.adid[key];
          let groupParam = {
            adid: adid
          }
          const allIds = await this.fetchGroupByLastId(groupParam);

          let campaignIds = allIds.join(',');
          let parms = {
            token: this.sks,
            adid: adid,
            campaignId: campaignIds,
            startAndStop: 1
          };
          await this.offGoundId(parms);
        }
      } else {
        for (let keys in this.planids) {
          let parms = {
            //危险
            token: this.sks,
            adid: this.adid[keys],
            campaignId: this.planids[keys],
            startAndStop: 1
          }
          await this.offGoundId(parms);
        }
      }

    },
    // 广告组列表快速查询
    async fetchGroupByLastId(param) {
      let lastId = 0;
      let allIds = [];

      while (true) {
        let time = Date.now().toString();
        let nonce = Math.round(Math.random() * 100000000000);

        let res = await this.$axios.post(
          'api/openapi/v1/ad/group/pageInfoByLastId?access_token=' + this.sks + '&timestamp=' + time + '&nonce=' + nonce + '&advertiser_id=' + param.adid,
          {
            lastId: lastId,
            deleted: 0,
            pageSize: 100
          }
        );

        let data = res.data.data.data;
        if (!data || data.length === 0) break;
        allIds.push(...data.map(item => item.id));

        if (data.length < res.data.data.pageSize) break; // 最后一页

        lastId = data[data.length - 1].id;
      }
      return allIds;
    },

    async onGround() {
      if (this.userUalue[1] === "mrqy") {
        this.sks = this.xiaobai[0]
      } else if (this.userUalue[1] === "qexs") {
        this.sks = this.xiaobai[1]
      } else if (this.userUalue[1] === "fhxs") {
        this.sks = this.xiaobai[3]
      } else if (this.userUalue[1] === "klxs") {
        this.sks = this.xiaobai[4]
      } else if (this.userUalue[1] === "ssxs") {
        this.sks = this.xiaobai[5]
      } else if (this.userUalue[1] === "hmxs") {
        this.sks = this.xiaobai[6]
      } else if (this.userUalue[1] === "htxs") {
        this.sks = this.xiaobai[7]
      } else if (this.userUalue[1] === "fjyk") {
        this.sks = this.xiaobai[8]
      } else if (this.userUalue[1] === "smxs") {
        this.sks = this.xiaobai[9]
      } else if (this.userUalue[1] === "qkdj") {
        this.sks = this.xiaobai[10]
      } else if (this.userUalue[1] === "nyyxs") {
        this.sks = this.xiaobai[49]
      } else if (this.userUalue[1] === "aicp") {
        this.sks = this.xiaobai[12]
      } else if (this.userUalue[1] === "xsdq") {
        this.sks = this.xiaobai[13]
      } else if (this.userUalue[1] === "qdxs") {
        this.sks = this.xiaobai[14]
      } else if (this.userUalue[1] === "ysxs") {
        this.sks = this.xiaobai[15]
      } else if (this.userUalue[1] === "ggyd") {
        this.sks = this.xiaobai[16]
      } else if (this.userUalue[1] === "fmxs") {
        this.sks = this.xiaobai[17]
      } else if (this.userUalue[1] === "mdjc") {
        this.sks = this.xiaobai[18]
      } else if (this.userUalue[1] === "lmxs") {
        this.sks = this.xiaobai[19]
      } else if (this.userUalue[1] === "qinmu") {
        this.sks = this.xiaobai[20]
      } else if (this.userUalue[1] === "misu") {
        this.sks = this.xiaobai[21]
      } else if (this.userUalue[1] === "mxjc") {
        this.sks = this.xiaobai[22]
      } else if (this.userUalue[1] === "zssq") {
        this.sks = this.xiaobai[23]
      } else if (this.userUalue[1] === "fydj") {
        this.sks = this.xiaobai[24]
      } else if (this.userUalue[1] === "taotie") {
        this.sks = this.xiaobai[25]
      } else if (this.userUalue[1] === "hdsw") {
        this.sks = this.xiaobai[26]
      } else if (this.userUalue[1] === "xinzssq") {
        this.sks = this.xiaobai[27]
      } else if (this.userUalue[1] === "zhuyun") {
        this.sks = this.xiaobai[28]
      } else if (this.userUalue[1] === "zssqx") {
        this.sks = this.xiaobai[29]
      } else if (this.userUalue[1] === "hdswx") {
        this.sks = this.xiaobai[30]
      } else if (this.userUalue[1] === "xinlm") {
        this.sks = this.xiaobai[31]
      } else if (this.userUalue[1] === "hdpsl") {
        this.sks = this.xiaobai[32]
      } else if (this.userUalue[1] === "smxsxin") {
        this.sks = this.xiaobai[33]
      } else if (this.userUalue[1] === "djpsl") {
        this.sks = this.xiaobai[34]
      } else if (this.userUalue[1] === "qdxgj") {
        this.sks = this.xiaobai[35]
      } else if (this.userUalue[1] === "xmll") {
        this.sks = this.xiaobai[36]
      } else if (this.userUalue[1] === "smdk3") {
        this.sks = this.xiaobai[37]
      } else if (this.userUalue[1] === "yiping") {
        this.sks = this.xiaobai[38]
      } else if (this.userUalue[1] === "momao") {
        this.sks = this.xiaobai[39]
      } else if (this.userUalue[1] === "yipingbj") {
        this.sks = this.xiaobai[40]
      } else if (this.userUalue[1] === "malilian") {
        this.sks = this.xiaobai[41]
      } else if (this.userUalue[1] === "qlyss") {
        this.sks = this.xiaobai[42]
      } else if (this.userUalue[1] === "mfxx") {
        this.sks = this.xiaobai[43]
      } else if (this.userUalue[1] === "zjfy") {
        this.sks = this.xiaobai[44]
      } else if (this.userUalue[1] === "fjfy") {
        this.sks = this.xiaobai[45]
      } else if (this.userUalue[1] === "ydd") {
        this.sks = this.xiaobai[46]
      } else if (this.userUalue[1] === "mgdj") {
        this.sks = this.xiaobai[47]
      } else if (this.userUalue[1] === "fy3") {
        this.sks = this.xiaobai[48]
      } else if (this.userUalue[1] === "shouhen") {
        this.sks = this.xiaobai[50]
      } else if (this.userUalue[1] === "fmcp") {
        this.sks = this.xiaobai[51]
      } else if (this.userUalue[1] === "hqdd") {
        this.sks = this.xiaobai[52]
      } else if (this.userUalue[1] === "sls") {
        this.sks = this.xiaobai[53]
      } else if (this.userUalue[1] === "llxs") {
        this.sks = this.xiaobai[54]
      } else if (this.userUalue[1] === "fjdj") {
        this.sks = this.xiaobai[55]
      } else if (this.userUalue[1] === "ygyd") {
        this.sks = this.xiaobai[56]
      } else if (this.userUalue[1] === "ezjd") {
        this.sks = this.xiaobai[57]
      }else if (this.userUalue[1] === "sumon") {
        this.sks = this.xiaobai[58]
      }   else if (this.userUalue[1] === "aicz") {
        this.sks = this.xiaobai[59]
      }
      else if (this.userUalue[1] === "gglys") {
        this.sks = this.xiaobai[60]
      }
      else if (this.userUalue[1] === "pslxtt") {
        this.sks = this.xiaobai[61]
      }
      else if (this.userUalue[1] === "yygl") {
        this.sks = this.xiaobai[62]
      }
      else if (this.userUalue[1] === "fyzm3") {
        this.sks = this.xiaobai[63]
      }
      else if (this.userUalue[1] === "djh") {
        this.sks = this.xiaobai[64]
      }
      else if (this.userUalue[1] === "ezfy3") {
        this.sks = this.xiaobai[65]
      }
      else if (this.userUalue[1] === "fjzy") {
        this.sks = this.xiaobai[66]
      }
      else if (this.userUalue[1] === "lingmao") {
        this.sks = this.xiaobai[67]
      }
      else if (this.userUalue[1] === "sdjl") {
        this.sks = this.xiaobai[68]
      }
      else if (this.userUalue[1] === "shushen") {
        this.sks = this.xiaobai[69]
      }
      else if (this.userUalue[1] === "ezht") {
        this.sks = this.xiaobai[70]
      }
      else if (this.userUalue[1] === "chaungyou") {
        this.sks = this.xiaobai[71]
      }
      else if (this.userUalue[1] === "yuyong") {
        this.sks = this.xiaobai[72]
      }
      else if (this.userUalue[1] === "zhiyue") {
        this.sks = this.xiaobai[73]
      }
      else if (this.userUalue[1] === "xzs3") {
        this.sks = this.xiaobai[74]
      }
      else if (this.userUalue[1] === "fjlldk") {
        this.sks = this.xiaobai[75]
      }
      this.planids = this.textarea2.trim().split(/\n/);
      // this.adid = this.textarea1.trim().split(/\n/);
      this.adid = await  this.confimuuid(this.textarea1)

      if (this.planids == "全部") {
        for (let key in this.adid) {
          let adid = this.adid[key];
          let groupParam = {
            adid: adid
          }
          const allIds = await this.fetchGroupByLastId(groupParam);

          let campaignIds = allIds.join(',');
          let parms = {
            token: this.sks,
            adid: adid,
            campaignId: campaignIds,
            startAndStop: 0
          };
          await this.offGoundId(parms);
        }
      } else {
        for (let keys in this.planids) {
          let parms = {
            //危险
            token: this.sks,
            adid: this.adid[keys],
            campaignId: this.planids[keys],
            startAndStop: 0
          }
          await this.offGoundId(parms);
        }
      }

    },
    //投放日期
    async edit(row) {
      if (this.userUalue[1] === "mrqy") {
        this.sks = this.xiaobai[0]
      } else if (this.userUalue[1] === "qexs") {
        this.sks = this.xiaobai[1]
      } else if (this.userUalue[1] === "fhxs") {
        this.sks = this.xiaobai[3]
      } else if (this.userUalue[1] === "klxs") {
        this.sks = this.xiaobai[4]
      } else if (this.userUalue[1] === "ssxs") {
        this.sks = this.xiaobai[5]
      } else if (this.userUalue[1] === "hmxs") {
        this.sks = this.xiaobai[6]
      } else if (this.userUalue[1] === "htxs") {
        this.sks = this.xiaobai[7]
      } else if (this.userUalue[1] === "fjyk") {
        this.sks = this.xiaobai[8]
      } else if (this.userUalue[1] === "smxs") {
        this.sks = this.xiaobai[9]
      } else if (this.userUalue[1] === "qkdj") {
        this.sks = this.xiaobai[10]
      } else if (this.userUalue[1] === "nyyxs") {
        this.sks = this.xiaobai[49]
      } else if (this.userUalue[1] === "aicp") {
        this.sks = this.xiaobai[12]
      } else if (this.userUalue[1] === "xsdq") {
        this.sks = this.xiaobai[13]
      } else if (this.userUalue[1] === "qdxs") {
        this.sks = this.xiaobai[14]
      } else if (this.userUalue[1] === "ysxs") {
        this.sks = this.xiaobai[15]
      } else if (this.userUalue[1] === "ggyd") {
        this.sks = this.xiaobai[16]
      } else if (this.userUalue[1] === "fmxs") {
        this.sks = this.xiaobai[17]
      } else if (this.userUalue[1] === "mdjc") {
        this.sks = this.xiaobai[18]
      } else if (this.userUalue[1] === "lmxs") {
        this.sks = this.xiaobai[19]
      } else if (this.userUalue[1] === "qinmu") {
        this.sks = this.xiaobai[20]
      } else if (this.userUalue[1] === "misu") {
        this.sks = this.xiaobai[21]
      } else if (this.userUalue[1] === "mxjc") {
        this.sks = this.xiaobai[22]
      } else if (this.userUalue[1] === "zssq") {
        this.sks = this.xiaobai[23]
      } else if (this.userUalue[1] === "fydj") {
        this.sks = this.xiaobai[24]
      } else if (this.userUalue[1] === "taotie") {
        this.sks = this.xiaobai[25]
      } else if (this.userUalue[1] === "hdsw") {
        this.sks = this.xiaobai[26]
      } else if (this.userUalue[1] === "xinzssq") {
        this.sks = this.xiaobai[27]
      } else if (this.userUalue[1] === "zhuyun") {
        this.sks = this.xiaobai[28]
      } else if (this.userUalue[1] === "zssqx") {
        this.sks = this.xiaobai[29]
      } else if (this.userUalue[1] === "hdswx") {
        this.sks = this.xiaobai[30]
      } else if (this.userUalue[1] === "xinlm") {
        this.sks = this.xiaobai[31]
      } else if (this.userUalue[1] === "hdpsl") {
        this.sks = this.xiaobai[32]
      } else if (this.userUalue[1] === "smxsxin") {
        this.sks = this.xiaobai[33]
      } else if (this.userUalue[1] === "djpsl") {
        this.sks = this.xiaobai[34]
      } else if (this.userUalue[1] === "qdxgj") {
        this.sks = this.xiaobai[35]
      } else if (this.userUalue[1] === "xmll") {
        this.sks = this.xiaobai[36]
      } else if (this.userUalue[1] === "smdk3") {
        this.sks = this.xiaobai[37]
      } else if (this.userUalue[1] === "yiping") {
        this.sks = this.xiaobai[38]
      } else if (this.userUalue[1] === "momao") {
        this.sks = this.xiaobai[39]
      } else if (this.userUalue[1] === "yipingbj") {
        this.sks = this.xiaobai[40]
      } else if (this.userUalue[1] === "malilian") {
        this.sks = this.xiaobai[41]
      } else if (this.userUalue[1] === "qlyss") {
        this.sks = this.xiaobai[42]
      } else if (this.userUalue[1] === "mfxx") {
        this.sks = this.xiaobai[43]
      } else if (this.userUalue[1] === "zjfy") {
        this.sks = this.xiaobai[44]
      } else if (this.userUalue[1] === "fjfy") {
        this.sks = this.xiaobai[45]
      } else if (this.userUalue[1] === "ydd") {
        this.sks = this.xiaobai[46]
      } else if (this.userUalue[1] === "mgdj") {
        this.sks = this.xiaobai[47]
      } else if (this.userUalue[1] === "fy3") {
        this.sks = this.xiaobai[48]
      } else if (this.userUalue[1] === "shouhen") {
        this.sks = this.xiaobai[50]
      } else if (this.userUalue[1] === "fmcp") {
        this.sks = this.xiaobai[51]
      } else if (this.userUalue[1] === "hqdd") {
        this.sks = this.xiaobai[52]
      } else if (this.userUalue[1] === "sls") {
        this.sks = this.xiaobai[53]
      } else if (this.userUalue[1] === "llxs") {
        this.sks = this.xiaobai[54]
      } else if (this.userUalue[1] === "fjdj") {
        this.sks = this.xiaobai[55]
      } else if (this.userUalue[1] === "ygyd") {
        this.sks = this.xiaobai[56]
      } else if (this.userUalue[1] === "ezjd") {
        this.sks = this.xiaobai[57]
      }else if (this.userUalue[1] === "sumon") {
        this.sks = this.xiaobai[58]
      }   else if (this.userUalue[1] === "aicz") {
        this.sks = this.xiaobai[59]
      }
      else if (this.userUalue[1] === "gglys") {
        this.sks = this.xiaobai[60]
      }
      else if (this.userUalue[1] === "pslxtt") {
        this.sks = this.xiaobai[61]
      }
      else if (this.userUalue[1] === "yygl") {
        this.sks = this.xiaobai[62]
      }
      else if (this.userUalue[1] === "fyzm3") {
        this.sks = this.xiaobai[63]
      }
      else if (this.userUalue[1] === "djh") {
        this.sks = this.xiaobai[64]
      }
      else if (this.userUalue[1] === "ezfy3") {
        this.sks = this.xiaobai[65]
      }
      else if (this.userUalue[1] === "fjzy") {
        this.sks = this.xiaobai[66]
      }
      else if (this.userUalue[1] === "lingmao") {
        this.sks = this.xiaobai[67]
      }
      else if (this.userUalue[1] === "sdjl") {
        this.sks = this.xiaobai[68]
      }
      else if (this.userUalue[1] === "shushen") {
        this.sks = this.xiaobai[69]
      }
      else if (this.userUalue[1] === "ezht") {
        this.sks = this.xiaobai[70]
      }
      else if (this.userUalue[1] === "chaungyou") {
        this.sks = this.xiaobai[71]
      }
      else if (this.userUalue[1] === "yuyong") {
        this.sks = this.xiaobai[72]
      }
      else if (this.userUalue[1] === "zhiyue") {
        this.sks = this.xiaobai[73]
      }
      else if (this.userUalue[1] === "xzs3") {
        this.sks = this.xiaobai[74]
      }
      else if (this.userUalue[1] === "fjlldk") {
        this.sks = this.xiaobai[75]
      }
      this.dialog1 = true;
      this.planids = this.textarea2.trim().split(/\n/);
      // this.adid = this.textarea1.trim().split(/\n/);
      this.adid = await  this.confimuuid(this.textarea1)


    },

    /**一键起量
     *
     *
     * @param pams
     * @returns {Promise<void>}
     * @constructor
     */
    async Postoffer1(pams) {
      let time = parseInt(new Date().getTime()) + '';
      let nonce2 = Math.round(Math.random() * 100000000000)
      await this.$axios.post('api/openapi/v1/ad/group/updateFastFlow?access_token=' + pams.token + '&timestamp=' + time + '&nonce=' + nonce2 + '&advertiser_id=' + pams.adid,
        {
          "groupId": pams.id,
          "fastFlowBudget": pams.ocpxPrice,
          "fastFlowState": pams.price
        }).then(resp => {

        console.log(resp.data)
        if (resp.data.code === 70111) {
          this.$notify.error({
            title: '错误',
            message: '一键起量失败'
          });
        } else {
          this.$notify({
            title: '成功',
            message: '一键起量成功',
            type: 'success'
          });

        }

      })


    },
    async Postoffer(pams) {
      let time = parseInt(new Date().getTime()) + '';
      let nonce2 = Math.round(Math.random() * 100000000000)
      await this.$axios.post('api/openapi/v1/ad/group/batchEditPrice?access_token=' + pams.token + '&timestamp=' + time + '&nonce=' + nonce2 + '&advertiser_id=' + pams.adid,
        {
          "ids": pams.id,
          "ocpxPrice": pams.ocpxPrice,
          "price": pams.price
        }).then(resp => {

        console.log(resp.data)
        if (resp.data.code === 70111) {
          this.$notify.error({
            title: '错误',
            message: '修改二阶段出价失败'
          });
        } else {
          this.$notify({
            title: '成功',
            message: '修改二阶段出价成功',
            type: 'success'
          });

        }

      })


    },
    SendOffer() {
      console.log(this.groudId)
      let t2 = this.money3 * 100000
      let t3 = this.money2 * 100000
      for (let a in this.groudId) {
        let t1 = {
          id: this.groudId[a],
          ocpxPrice: t2,
          price: t3,
          token: this.sks,
          adid: this.adids
        }
        this.Postoffer(t1)
      }

      this.offer = false
    },
    SendOffer1() {
      console.log(this.groudId)
      let t2 = this.moneys * 100000
      let t3 = this.money2 * 100000
      for (let a in this.groudId) {
        let t1 = {
          id: this.groudId[a],
          ocpxPrice: t2,
          price: 1,
          token: this.sks,
          adid: this.adids
        }
        this.Postoffer1(t1)
      }

      this.offer = false
    },
    SendOffer2() {
      console.log(this.groudId)
      let t2 = this.moneys * 100000
      let t3 = this.money2 * 100000
      for (let a in this.groudId) {
        let t1 = {
          id: this.groudId[a],
          ocpxPrice: t2,
          price: 3,
          token: this.sks,
          adid: this.adids
        }
        this.Postoffer1(t1)
      }

      this.offer = false
    },
    async chujia(index, row) {
      this.money3 = 0;
      this.max = 0;
      let pams = {
        //危险
        token: this.sks,
        adid: row.uuid,
        adName: row.adName,
        campaignId: row.campaignId
      }
      this.adids = row.uuid
      await this.PostGroup3(pams)
      await this.yijianqiliangcode(pams)

      this.max = this.numtest[0].ocpxPrice;
      if (this.numtest.length = 1) {
        this.money3 = this.numtest[0].ocpxPrice;
      } else {
        for (let i = 1; i < this.numtest.length; i++) {
          console.log(this.numtest[i].ocpxPrice)
          if (this.numtest[i].ocpxPrice > this.max) {
            this.money3 = this.numtest[i].ocpxPrice;
          } else {
            this.money3 = this.max

          }

        }
      }

      this.money3 = this.money3 / 100000
      this.offer = true;
    },
    updateEd1() {
      console.log(this.kaiguan)
      if (this.kaiguan === 0) {
        let t1 = {
          id: this.grouplist.campaignId,
          dailyBudget: -1,
          token: this.sks,
          adid: this.grouplist.userId
        }
        this.PostMoeny(t1)
      } else if (this.kaiguan === 1) {
        let t1 = {
          id: this.grouplist.campaignId,
          dailyBudget: this.money * 100000,
          token: this.sks,
          adid: this.grouplist.userId
        }
        this.PostMoeny(t1)


      }


      this.dialog2 = false

    },

//修改限额api
    edit1(row) {
      console.log(row)
      this.grouplist = {}
      this.grouplist = {
        campaignId: row.campaignId,
        userId: row.userId,
      }
      this.dialog2 = true
    },
    async PostMoeny(pams) {
      let time = parseInt(new Date().getTime()) + '';
      let nonce2 = Math.round(Math.random() * 100000000000)
      await this.$axios.post('api/openapi/v1/ad/campaign/editDailyBudget?access_token=' + pams.token + '&timestamp=' + time + '&nonce=' + nonce2 + '&advertiser_id=' + pams.adid,
        {
          "id": pams.id,
          "dailyBudget": pams.dailyBudget,
        }).then(resp => {

        console.log(resp.data)
        if (resp.data.code === 70111) {
          this.$notify.error({
            title: '错误',
            message: '修改限额失败，请检测限额是否错误'
          });
        } else {
          this.$notify({
            title: '成功',
            message: '修改限额成功',
            type: 'success'
          });

        }

      })


    },
    async yijianqiliangcode(pams) {
      this.groudId1 = []
      let time = parseInt(new Date().getTime()) + '';
      let nonce2 = Math.round(Math.random() * 100000000000)
      await this.$axios.post('api/openapi/v1/ad/group/getFastFlowInfoByGroupIds?access_token=' + pams.token + '&timestamp=' + time + '&nonce=' + nonce2 + '&advertiser_id=' + pams.adid,
        {
          "groupIds": this.groudId[0],
        }).then(resp => {
        // console.log(resp.data[0].fastFlowState)
        if (resp.data.data === undefined) {
          this.qiliangcode = 0;
        } else {
          console.log(resp.data.data)
          this.qiliangcode = resp.data.data[0].fastFlowState;


        }
        // if (resp.data.datas[0])
      })


    },
    async PostGroup1(pams) {

      let time = parseInt(new Date().getTime()) + '';
      let nonce2 = Math.round(Math.random() * 100000000000)
      await this.$axios.post('api/openapi/v1/ad/group/batchEditDate?access_token=' + pams.token + '&timestamp=' + time + '&nonce=' + nonce2 + '&advertiser_id=' + pams.adid,
        {
          "ids": pams.ids,
          "startDate": pams.startDate,
          "endDate": pams.endDate
        }).then(resp => {

        if (resp.data.code === 70111) {
          this.$notify.error({
            title: '错误',
            message: '修改投放日期失败，请检查日期是否错误'
          });
        } else {
          this.$notify({
            title: '成功',
            message: '修改投放日期成功',
            type: 'success',
            position: 'bottom-left'
          });
        }

      })


    },
    async updateTime1() {
      // for(let a=0;a<this.datas.length;a++){
      //   console.log(this.datas[a].uuid)
      // }
      for (let a = 0; a < this.datas.length; a++) {
        this.groudId = []
        let parms = {
          token: this.sks,
          adid: this.datas[a].uuid,
        }
        // console.log(parms)
        await this.queryPlanId(parms)
        console.log(this.planid)
        for (let key in this.planid) {
          let pams = {
            //危险
            token: this.sks,
            adid: this.datas[a].uuid,
            campaignId: this.planid[key],
          }
          this.adids = this.datas[a].uuid,
            await this.PostGroup4(pams)

          // console.log(this.groudId)
        }
        let endtime = '2038-01-19'
        if (this.kaiguan === 0) {
          //发送
          for (let a = 0; a < this.groudId.length; a++) {
            let pams = {
              ids: this.groudId[a],
              startDate: this.value3,
              endDate: endtime,
              token: this.sks,
              adid: this.adids
            }

            await this.PostGroup1(pams)
          }

        } else if (this.kaiguan === 1) {
          for (let a = 0; a < this.groudId.length; a++) {
            let pams = {
              ids: this.groudId[a],
              startDate: this.value2.at(0),
              endDate: this.value2.at(1),
              token: this.sks,
              adid: this.adids
            }
            await this.PostGroup1(pams)
          }
        }
        if (a === this.datas.length - 1) {
          alert("批量关闭OK")
          this.dialog3 = false
        }
      }

    },
    //投放时间方法提交
    async updateTime() {
      let endtime = '2038-01-19'
      if (this.kaiguan === 0) {

        //发送
        if (this.planids == "全部") {
          for (let keys in this.adid) {
            let parms = {
              //危险
              token: this.sks,
              adid: this.adid[keys],
              startAndStop: 1
            }
            let time = parseInt(new Date().getTime()) + '';
            let nonce = Math.round(Math.random() * 100000000000)
            await this.$axios.post('api/openapi/v1/ad/campaign/pageInfoByLastId?access_token=' + parms.token + '&timestamp=' + time + '&nonce=' + nonce + '&advertiser_id=' + parms.adid, {
              "lastId": 0,
              "deleted": 0,
              "pageSize": 100
            }).then(async res => {
              for (const item of res.data.data.data) {
                this.groudId = [];
                let pams = {
                  token: this.sks,
                  adid: this.adid[keys],
                  campaignId: item.id
                };
                this.adids = this.adid[keys];
                await this.PostGroup3(pams);
                for (let a = 0; a < this.groudId.length; a++) {
                  let pams = {
                    ids: this.groudId[a],
                    startDate: this.value3,
                    endDate: endtime,
                    token: this.sks,
                    adid: this.adids
                  };
                  await this.PostGroup1(pams);
                }
              }
            });

          }

        } else {
          for (let keys in this.planids) {
            this.groudId = []
            let pams = {
              //危险
              token: this.sks,
              adid: this.adid[keys],
              campaignId: this.planids[keys]
            }
            this.adids = this.adid[keys]
            await this.PostGroup3(pams)
            for (let a = 0; a < this.groudId.length; a++) {
              let pams = {
                ids: this.groudId[a],
                startDate: this.value3,
                endDate: endtime,
                token: this.sks,
                adid: this.adids
              }
              await this.PostGroup1(pams)
            }
          }
        }


      } else if (this.kaiguan === 1) {
        if (this.planids == "全部") {
          for (let keys in this.adid) {
            let parms = {
              //危险
              token: this.sks,
              adid: this.adid[keys],
              startAndStop: 1
            }
            let time = parseInt(new Date().getTime()) + '';
            let nonce = Math.round(Math.random() * 100000000000)
            await this.$axios.post('api/openapi/v1/ad/campaign/pageInfoByLastId?access_token=' + parms.token + '&timestamp=' + time + '&nonce=' + nonce + '&advertiser_id=' + parms.adid, {
              "lastId": 0,
              "deleted": 0,
              "pageSize": 100
            }).then(async res => {
              for (const item of res.data.data.data) {
                this.groudId = [];
                let pams = {
                  token: this.sks,
                  adid: this.adid[keys],
                  campaignId: item.id
                };
                this.adids = this.adid[keys];
                await this.PostGroup3(pams);
                for (let a = 0; a < this.groudId.length; a++) {
                  let pams2 = {
                    ids: this.groudId[a],
                    startDate: this.value2.at(0),
                    endDate: this.value2.at(1),
                    token: this.sks,
                    adid: this.adids
                  };
                  await this.PostGroup1(pams2);
                }
              }
            });

          }

        } else {
          for (let keys in this.planids) {
            this.groudId = []
            let pams = {
              //危险
              token: this.sks,
              adid: this.adid[keys],
              campaignId: this.planids[keys]
            }
            this.adids = this.adid[keys]
            await this.PostGroup3(pams)
            for (let a = 0; a < this.groudId.length; a++) {
              let pams = {
                ids: this.groudId[a],
                startDate: this.value2.at(0),
                endDate: this.value2.at(1),
                token: this.sks,
                adid: this.adids
              }
              await this.PostGroup1(pams)
            }
          }
        }

      }

      this.dialog1 = false
    },
    //面板状态

    //面板状态
    boo(tab) {
      if (tab.name === "first") {
        this.kaiguan = 0
      } else if (tab.name === "erqi") {
        this.kaiguan = 12
      } else if (tab.name === "erba") {
        this.kaiguan = 13
      } else if (tab.name === "erjiu") {
        this.kaiguan = 14
      } else if (tab.name === "ershi") {
        this.kaiguan = 15
      } else if (tab.name === "ershiyi") {
        this.kaiguan = 16
      } else if (tab.name === "ershier") {
        this.kaiguan = 17
      } else if (tab.name === "sanqi") {
        this.kaiguan = 18
      } else if (tab.name === "sanba") {
        this.kaiguan = 19
      } else if (tab.name === "sanjiu") {
        this.kaiguan = 20
      } else if (tab.name === "sanshi") {
        this.kaiguan = 21
      } else if (tab.name === "sanshiyi") {
        this.kaiguan = 22
      } else if (tab.name === "sanshier") {
        this.kaiguan = 23
      } else if (tab.name === "second") {
        this.kaiguan = 1
      } else if (tab.name === "two") {
        this.kaiguan = 2
      } else if (tab.name === "second1") {
        this.kaiguan = 3
      } else if (tab.name === "second2") {
        this.kaiguan = 4
      } else if (tab.name === "second3") {
        this.kaiguan = 5
      } else if (tab.name === "second4") {
        this.kaiguan = 6
      } else if (tab.name === "second5") {
        this.kaiguan = 7
      } else if (tab.name === "two2") {
        this.kaiguan = 8
      } else if (tab.name === "two4") {
        this.kaiguan = 9
      } else if (tab.name === "two5") {
        this.kaiguan = 10
      } else if (tab.name === "two6") {
        this.kaiguan = 11
      } else if (tab.name === "qidianhou") {
        this.kaiguan = 70
      } else if (tab.name === "yidian") {
        this.kaiguan = 71
      } else if (tab.name === "sandian") {
        this.kaiguan = 72
      } else if (tab.name === "sidian") {
        this.kaiguan = 73
      } else if (tab.name === "liudian") {
        this.kaiguan = 74
      }


    },
    //修改日期
    async PostGroupTime(pams) {

      let time = parseInt(new Date().getTime()) + '';
      let nonce2 = Math.round(Math.random() * 100000000000)
      await this.$axios.post('api/openapi/v1/ad/group/batchEditTime?access_token=' + pams.token + '&timestamp=' + time + '&nonce=' + nonce2 + '&advertiser_id=' + pams.adid,
        {
          "ids": pams.ids,
          "scheduleTime": pams.scheduleTime,

        }).then(resp => {

        if (resp.data.code === 70111) {
          this.$notify.error({
            title: '错误',
            message: '修改投放时段失败，请检查时段是否错误'
          });
        } else {
          this.$notify({
            title: '成功',
            message: '修改投放时段成功',
            type: 'success',
            position: 'bottom-left'
          });
          this.dialog = false
        }

      })


    },
    async PostGroup2(pams) {
      let time = parseInt(new Date().getTime()) + '';
      let nonce2 = Math.round(Math.random() * 100000000000)
      await this.$axios.post('api/openapi/v1/ad/advertisement/pageInfo?access_token=' + pams.token + '&timestamp=' + time + '&nonce=' + nonce2 + '&advertiser_id=' + pams.adid,
        {
          "campaignId": pams.campaignId,
        }).then(resp => {

        console.log(resp.data.data.list)
        for (let key in resp.data.data.list) {
          // this.groudId[key]=resp.data.data.list[key].groupId
          this.groudId.push(resp.data.data.list[key].groupId)
        }

      })

    },
    async PostGroup(pams) {
      this.groudId = []

      let time = parseInt(new Date().getTime()) + '';
      let nonce2 = Math.round(Math.random() * 100000000000)
      await this.$axios.post('api/openapi/v1/ad/advertisement/pageInfo?access_token=' + pams.token + '&timestamp=' + time + '&nonce=' + nonce2 + '&advertiser_id=' + pams.adid,
        {
          "campaignId": pams.campaignId,
        }).then(resp => {

        console.log(resp.data.data.list)
        for (let key in resp.data.data.list) {
          this.groudId[key] = resp.data.data.list[key].groupId
        }

      })

    },
    async PostGroup4(pams) {
      console.log(pams.campaignId)
      let time = parseInt(new Date().getTime()) + '';
      let nonce2 = Math.round(Math.random() * 100000000000)
      await this.$axios.post('api/openapi/v1/ad/group/pageInfo?access_token=' + pams.token + '&timestamp=' + time + '&nonce=' + nonce2 + '&advertiser_id=' + pams.adid,
        {
          "campaignId": pams.campaignId,
          "pageIndex": 1,
          "pageSize": 100,
        }).then(resp => {

        for (let key in resp.data.data.list) {
          // console.log("广告组id")
          // console.log(resp.data.data.list)
          this.groudId.push(resp.data.data.list[key].id)
        }
        this.numtest = resp.data.data.list

      })
    },
    async PostGroup3(pams) {
      this.groudId = []
      let time = parseInt(new Date().getTime()) + '';
      let nonce2 = Math.round(Math.random() * 100000000000)
      await this.$axios.post('api/openapi/v1/ad/group/pageInfo?access_token=' + pams.token + '&timestamp=' + time + '&nonce=' + nonce2 + '&advertiser_id=' + pams.adid,
        {
          "campaignId": pams.campaignId,
          "pageIndex": 1,
          "pageSize": 100,
        }).then(resp => {

        for (let key in resp.data.data.list) {

          this.groudId[key] = resp.data.data.list[key].id
        }
        this.numtest = resp.data.data.list

      })
    },
    //投放时间


    //批量删除计划
    async delPlanId(parms) {


      if (this.planids == "全部") {
        for (let keys in this.adid) {
          let parms = {
            token: this.sks,
            adid: this.adid[keys],
            startAndStop: 1
          }
          let time = parseInt(new Date().getTime()) + '';
          let nonce = Math.round(Math.random() * 100000000000)

          try {
            let res = await this.$axios.post('api/openapi/v1/ad/campaign/pageInfoByLastId?access_token=' + parms.token + '&timestamp=' + time + '&nonce=' + nonce + '&advertiser_id=' + parms.adid, {
              "lastId": 0,
              "deleted": 0,
              "pageSize": 100
            });

            for (let item of res.data.data.data) {
              let parms = {
                //危险
                token: this.sks,
                adid: this.adid[keys],
                campaignId: item.id,
              }
              await this.delPlanIds(parms);
            }
          } catch (error) {
            console.error(error);
          }
        }
      } else {
        let time = parseInt(new Date().getTime()) + '';

        let nonce = Math.round(Math.random() * 100000000000)
        await this.$axios.post('api/openapi/v1/ad/campaign/batchDel?access_token=' + parms.token + '&timestamp=' + time + '&nonce=' + nonce + '&advertiser_id=' + parms.adid, {
          "ids": parms.campaignId
        }).then(async resDay => {

          this.$notify({
            title: '成功',
            message: '批量删除计划成功',
            type: 'success',
            position: 'bottom-left'
          });
        })
      }


    },

    async delPlanIds(parms) {
      let time = parseInt(new Date().getTime()) + '';

      let nonce = Math.round(Math.random() * 100000000000)
      await this.$axios.post('api/openapi/v1/ad/campaign/batchDel?access_token=' + parms.token + '&timestamp=' + time + '&nonce=' + nonce + '&advertiser_id=' + parms.adid, {
        "ids": parms.campaignId
      }).then(async resDay => {

        this.$notify({
          title: '成功',
          message: '批量删除计划成功',
          type: 'success',
          position: 'bottom-left'
        });
      })

    },
    //批量启停计划
    async offPlanId(parms) {
      let retry = async (parms) => {
        try {
          // 获取新的time和nonce
          let time = parseInt(new Date().getTime()) + '';
          let nonce = Math.round(Math.random() * 100000000000);

          // 发送请求
          const response = await this.$axios.post('api/openapi/v1/ad/campaign/pause/toggle?access_token=' + parms.token + '&timestamp=' + time + '&nonce=' + nonce + '&advertiser_id=' + parms.adid, {
            "ids": parms.campaignId,
            "startAndStop": parms.startAndStop
          });

          // 处理响应
          const {message} = response.data;
          if (message && message.trim() === "请求过于频繁") {
            // 如果请求过于频繁，等待1秒后重试
            await new Promise(resolve => setTimeout(resolve, 1000));
            retry(parms); // 递归调用重试函数
          } else {
            // 处理正常响应或其他错误消息
            if (parms.startAndStop === 1) {
              this.$notify({
                title: '成功',
                message: '批量关闭计划成功',
                type: 'success',
                position: 'bottom-left'
              });
            } else if (parms.startAndStop === 0) {
              this.$notify({
                title: '成功',
                message: '批量开启计划成功',
                type: 'success',
                position: 'bottom-left'
              });
            }
          }
        } catch (error) {
          // 处理请求错误
          console.error("请求出错:", error);
        }
      };

      // 首次调用重试函数
      retry(parms);
    },
    //批量启停广告组
    async offGoundId(parms) {
      let time = parseInt(new Date().getTime()) + '';

      let nonce = Math.round(Math.random() * 100000000000)
      await this.$axios.post('api/openapi/v1/ad/group/pause/toggle?access_token=' + parms.token + '&timestamp=' + time + '&nonce=' + nonce + '&advertiser_id=' + parms.adid, {
        "ids": parms.campaignId,
        "startAndStop": parms.startAndStop
      }).then(async resDay => {
        if (parms.startAndStop === 1) {
          this.$notify({
            title: '成功',
            message: '批量关闭计划成功',
            type: 'success',
            position: 'bottom-left'
          });
        } else if (parms.startAndStop === 0) {
          this.$notify({
            title: '成功',
            message: '批量开启计划成功',
            type: 'success',
            position: 'bottom-left'
          });
        }

      })

    },
    //查询计划
    async queryPlanId(parms) {
      let nonce = Math.round(Math.random() * 100000000000)
      await this.$axios.post('api/openapi/v1/ad/campaign/pageInfo?access_token=' + parms.token + '&timestamp=' + this.time + '&nonce=' + nonce + '&advertiser_id=' + parms.adid, {
        pageSize: '100'
      }).then(async resDay => {

        for (let key in resDay.data.data.list) {

          this.planid[key] = resDay.data.data.list[key].id
        }

      })

    },
    //显示表单
    async handleClick(row) {
      let status = this.userUalue[1]
      if (status === "mrqy") {
        this.sks = this.xiaobai[0]
      } else if (status === "qexs") {
        this.sks = this.xiaobai[1]
      } else if (status === "fhxs") {
        this.sks = this.xiaobai[3]
      } else if (status === "klxs") {
        this.sks = this.xiaobai[4]
      } else if (status === "ssxs") {
        this.sks = this.xiaobai[5]
      } else if (status === "hmxs") {
        this.sks = this.xiaobai[6]
      } else if (status === "htxs") {
        this.sks = this.xiaobai[7]
      } else if (this.userUalue[1] === "fjyk") {
        this.sks = this.xiaobai[8]
      } else if (this.userUalue[1] === "smxs") {
        this.sks = this.xiaobai[9]
      } else if (this.userUalue[1] === "qkdj") {
        this.sks = this.xiaobai[10]
      } else if (this.userUalue[1] === "nyyxs") {
        this.sks = this.xiaobai[49]
      } else if (this.userUalue[1] === "aicp") {
        this.sks = this.xiaobai[12]
      } else if (this.userUalue[1] === "xsdq") {
        this.sks = this.xiaobai[13]
      } else if (this.userUalue[1] === "qdxs") {
        this.sks = this.xiaobai[14]
      } else if (this.userUalue[1] === "ysxs") {
        this.sks = this.xiaobai[15]
      } else if (this.userUalue[1] === "ggyd") {
        this.sks = this.xiaobai[16]
      } else if (this.userUalue[1] === "fmxs") {
        this.sks = this.xiaobai[17]
      } else if (this.userUalue[1] === "mdjc") {
        this.sks = this.xiaobai[18]
      } else if (this.userUalue[1] === "lmxs") {
        this.sks = this.xiaobai[19]
      } else if (this.userUalue[1] === "qinmu") {
        this.sks = this.xiaobai[20]
      } else if (this.userUalue[1] === "misu") {
        this.sks = this.xiaobai[21]
      } else if (this.userUalue[1] === "mxjc") {
        this.sks = this.xiaobai[22]
      } else if (this.userUalue[1] === "zssq") {
        this.sks = this.xiaobai[23]
      } else if (this.userUalue[1] === "fydj") {
        this.sks = this.xiaobai[24]
      } else if (this.userUalue[1] === "taotie") {
        this.sks = this.xiaobai[25]
      } else if (this.userUalue[1] === "hdsw") {
        this.sks = this.xiaobai[26]
      } else if (this.userUalue[1] === "xinzssq") {
        this.sks = this.xiaobai[27]
      } else if (this.userUalue[1] === "zhuyun") {
        this.sks = this.xiaobai[28]
      } else if (this.userUalue[1] === "zssqx") {
        this.sks = this.xiaobai[29]
      } else if (this.userUalue[1] === "hdswx") {
        this.sks = this.xiaobai[30]
      } else if (this.userUalue[1] === "xinlm") {
        this.sks = this.xiaobai[31]
      } else if (this.userUalue[1] === "hdpsl") {
        this.sks = this.xiaobai[32]
      } else if (this.userUalue[1] === "smxsxin") {
        this.sks = this.xiaobai[33]
      } else if (this.userUalue[1] === "djpsl") {
        this.sks = this.xiaobai[34]
      } else if (this.userUalue[1] === "qdxgj") {
        this.sks = this.xiaobai[35]
      } else if (this.userUalue[1] === "xmll") {
        this.sks = this.xiaobai[36]
      } else if (this.userUalue[1] === "smdk3") {
        this.sks = this.xiaobai[37]
      } else if (this.userUalue[1] === "yiping") {
        this.sks = this.xiaobai[38]
      } else if (this.userUalue[1] === "momao") {
        this.sks = this.xiaobai[39]
      } else if (this.userUalue[1] === "yipingbj") {
        this.sks = this.xiaobai[40]
      } else if (this.userUalue[1] === "malilian") {
        this.sks = this.xiaobai[41]
      } else if (this.userUalue[1] === "qlyss") {
        this.sks = this.xiaobai[42]
      } else if (this.userUalue[1] === "mfxx") {
        this.sks = this.xiaobai[43]
      } else if (this.userUalue[1] === "zjfy") {
        this.sks = this.xiaobai[44]
      } else if (this.userUalue[1] === "fjfy") {
        this.sks = this.xiaobai[45]
      } else if (this.userUalue[1] === "ydd") {
        this.sks = this.xiaobai[46]
      } else if (this.userUalue[1] === "mgdj") {
        this.sks = this.xiaobai[47]
      } else if (this.userUalue[1] === "fy3") {
        this.sks = this.xiaobai[48]
      } else if (this.userUalue[1] === "shouhen") {
        this.sks = this.xiaobai[50]
      } else if (this.userUalue[1] === "fmcp") {
        this.sks = this.xiaobai[51]
      } else if (this.userUalue[1] === "hqdd") {
        this.sks = this.xiaobai[52]
      } else if (this.userUalue[1] === "sls") {
        this.sks = this.xiaobai[53]
      } else if (this.userUalue[1] === "llxs") {
        this.sks = this.xiaobai[54]
      } else if (this.userUalue[1] === "fjdj") {
        this.sks = this.xiaobai[55]
      } else if (this.userUalue[1] === "ygyd") {
        this.sks = this.xiaobai[56]
      } else if (this.userUalue[1] === "ezjd") {
        this.sks = this.xiaobai[57]
      }else if (this.userUalue[1] === "sumon") {
        this.sks = this.xiaobai[58]
      }   else if (this.userUalue[1] === "aicz") {
        this.sks = this.xiaobai[59]
      }
      else if (this.userUalue[1] === "gglys") {
        this.sks = this.xiaobai[60]
      }
      else if (this.userUalue[1] === "pslxtt") {
        this.sks = this.xiaobai[61]
      }
      else if (this.userUalue[1] === "yygl") {
        this.sks = this.xiaobai[62]
      }
      else if (this.userUalue[1] === "fyzm3") {
        this.sks = this.xiaobai[63]
      }
      else if (this.userUalue[1] === "djh") {
        this.sks = this.xiaobai[64]
      }
      else if (this.userUalue[1] === "ezfy3") {
        this.sks = this.xiaobai[65]
      }
      else if (this.userUalue[1] === "fjzy") {
        this.sks = this.xiaobai[66]
      }
      else if (this.userUalue[1] === "lingmao") {
        this.sks = this.xiaobai[67]
      }
      else if (this.userUalue[1] === "sdjl") {
        this.sks = this.xiaobai[68]
      }
      else if (this.userUalue[1] === "shushen") {
        this.sks = this.xiaobai[69]
      }
      else if (this.userUalue[1] === "ezht") {
        this.sks = this.xiaobai[70]
      }
      else if (this.userUalue[1] === "chaungyou") {
        this.sks = this.xiaobai[71]
      }
      else if (this.userUalue[1] === "yuyong") {
        this.sks = this.xiaobai[72]
      }
      else if (this.userUalue[1] === "zhiyue") {
        this.sks = this.xiaobai[73]
      }
      else if (this.userUalue[1] === "xzs3") {
        this.sks = this.xiaobai[74]
      }
      else if (this.userUalue[1] === "fjlldk") {
        this.sks = this.xiaobai[75]
      }
      this.dialog = true;
      this.planids = this.textarea2.trim().split(/\n/);
      this.adid = await  this.confimuuid(this.textarea1)




    },

    //切换开关
    changeSwitch(value, row, index) {
      if (this.userUalue[1] === "mrqy") {
        let time1 = parseInt(new Date().getTime()) + '';
        let nonce = Math.round(Math.random() * 100000000000)
        const {id, pauseState, userId} = row

        let params = {
          userId: userId,
          id: id,
          pauseState: pauseState ? '1' : '0'  // 三元运算符  类似于if else
        };

        this.$axios.post('api/openapi/v1/ad/campaign/pause/toggle?access_token=' + this.sks + '&timestamp=' +
          time1 + '&nonce=' + nonce + '&advertiser_id=' + params.userId, {
          ids: params.id,
          startAndStop: params.pauseState
        }).then(async res => {
          if (res.data.code === 0) {
            this.$message.success(`${pauseState ? '已停用' : '已启用'}`)
          }
        })

      } else {
        let time1 = parseInt(new Date().getTime()) + '';
        let nonce = Math.round(Math.random() * 100000000000)
        const {id, pauseState, userId} = row

        let params = {
          userId: userId,
          id: id,
          pauseState: pauseState ? '1' : '0'  // 三元运算符  类似于if else
        };

        this.$axios.post('api/openapi/v1/ad/campaign/pause/toggle?access_token=' + this.sks + '&timestamp=' +
          time1 + '&nonce=' + nonce + '&advertiser_id=' + params.userId, {
          ids: params.id,
          startAndStop: params.pauseState
        }).then(async res => {
          if (res.data.code === 0) {
            this.$message.success(`${pauseState ? '已停用' : '已启用'}`)
          }
        })

      }

    },
    //汇总 格式化合计行
    getSummaries(param) {
      const {columns, data} = param;
      const sums = [];
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = '总汇';
          return;
        }
        if (index === 9) {
          sums[index] = ''

          return;

        }

        if (index === 10) {
          sums[index] = sums[index - 2] / sums[index - 4];
          sums[index] = sums[index].toFixed(4);
          return;

        }

        if (index === 14) {
          sums[index] = sums[index - 6] / sums[index - 1];
          sums[index] = sums[index].toFixed(4);
          return;

        }

        if (index === 16) {
          sums[index] = sums[index - 8] / sums[index - 11];
          sums[index] = sums[index].toFixed(4);
          sums[index] = sums[index] * 100 + '%'
          return;

        }
        if (index === 17) {
          sums[index] = sums[index - 4] / sums[index - 11];
          sums[index] = sums[index].toFixed(4);
          sums[index] = sums[index] * 100 + '%'
          return;

        }


        const values = data.map(item => Number(item[column.property]));
        if (!values.every(value => isNaN(value))) {
          sums[index] = values.reduce((prev, curr) => {
            const value = Number(curr);
            if (!isNaN(value)) {
              return prev + curr;
            } else {
              return prev;
            }
          }, 0);

          sums[index] = sums[index].toFixed(2) + "";
        } else {
          sums[index] = '';
        }
      });

      return sums;
    },
    //导出文档api
    exportExcel() {
      excel('exportTab', '数据导出')
    },


    //表单格式规则
    rule(row, column) {
      if (row[column.property] === undefined) {
        return null
      } else {
        var percent = (row[column.property]).toFixed(2)
        return percent
      }
    },
    //加百分号
    ChangeToPercentage: function (row, column) {
      if (row[column.property] === undefined) {
        return null
      } else {
        var percent = (row[column.property] * 100).toFixed(2) + '%'
        return percent
      }

    },

    rule1(row, column) {

      if (row[column.property] === -1) {
        return '未限额'
      } else {
        var percent = row[column.property] / 100000
        return percent
      }
    },
    // 获取时间戳，获取时间选择器时间
    chooseTimeRange(value1) {
      this.time = parseInt(new Date().getTime()) + '';
      this.value2 = value1;

    },
    //查询函数
    async getDataList1() {
      this.dialog3 = true

    },
    getDataList() {
      //清空列表，数组
      this.time = parseInt(new Date().getTime()) + '';
      this.datanums[0].nuMshowCount = 0
      this.datanums[0].nuMclickCount = 0
      this.datanums[0].nuMspent = 0
      this.datanums[0].nuMformsubmitCount = 0
      this.datanums[0].nuMbalance = 0
      this.datanums[0].nuMdisGeneralBalance = 0
      this.datanums[0].nuMcustomPayCount = 0
      this.datanums[0].nuMreactivation = 0
      this.datanums[0].nuMcustomRetainCount = 0
      this.datas = null
      this.datadata = []
      this.namedata = []
      this.playCode = []
      this.temp2 = []
      this.temp1 = []
      this.temp = []

      //判断是否为小白进入下方，查询按钮禁用
      if (this.userUalue[0] === "xiaobai") {
        this.isDisable = true
        //调起接口
        this.TimeChangeto1();
      }

    },
    //合并json
    hb(jsonbject1, jsonbject2) {
      var resultJsonObject = {};
      for (var attr in jsonbject1) {
        resultJsonObject[attr] = jsonbject1[attr];
      }
      for (var attr in jsonbject2) {
        resultJsonObject[attr] = jsonbject2[attr];
      }
      return resultJsonObject;
    },
    //按天查询所有户
    async queryDay(list) {
      let nonce = Math.round(Math.random() * 100000000000)
      await this.$axios.post('api/openapi/v1/adstatement/summary/query?access_token=' + list.token + '&timestamp=' + this.time + '&nonce=' + nonce + '&advertiser_id=' + list.adid[list.a], {
        startDate: list.startDate,
        endDate: list.endDate,
        pageIndex: "1",
        pageSize: "100",
        summaryType: "DAY",
        level: list.level
      }).then(async resDay => {
        this.len = resDay.data.data.items.length;
        return resDay;
      })
    },
    //查询广告
    async PostListQuery(parms) {

      this.$message.success("正在查询第" + parms.a + "条")
      let nonce = Math.round(Math.random() * 100000000000)
      await this.$axios.post('api/openapi/v1/adstatement/summary/query?access_token=' + parms.token + '&timestamp=' + this.time + '&nonce=' + nonce + '&advertiser_id=' + parms.adid[parms.a], {
        startDate: parms.startDate,
        endDate: parms.endDate,
        pageIndex: "1",
        pageSize: "100",
        summaryType: parms.summaryType,
        level: parms.level
      }).then(async resp => {
        if (resp.data.code !== 60806) {
          if (resp.data.data.items != null) {
            if (this.value === "HOUR") {
              let arr = [];
              arr = [];
              let map = new Map;
              map.clear();
              for (let key in resp.data.data.items) {
                var time = new Date(resp.data.data.items[key].reportTime)
                let reTimeHour = time.getHours(); //获取返回整点时间
                var date = new Date()
                let hour = date.getHours();  // 获取当前时间
                if (hour === reTimeHour) {
                  arr.push(key)   //定位现在整时位置
                  map.set(key, resp.data.data.items[key])// 记录下现在的数据
                }
              }
              for (let keys in arr) {

                this.datadata.push(map.get(arr[keys]))
                let obj = {
                  ids: resp.data.data.items[arr[keys]].campaignId,
                  lengths: arr.length
                }
                let pams = Object.assign(obj, parms)
                await this.PostListplayCode(pams)
              }
              let obj1 = {
                lengths: arr.length
              }
              parms = Object.assign(obj1, parms)
              await this.GetListUserId(parms);

            } else {
              for (let b = 0; b < resp.data.data.items.length; b++) {
                this.datadata.push(resp.data.data.items[b])
                let obj = {
                  ids: resp.data.data.items[b].campaignId,
                  lengths: resp.data.data.items.length
                }
                let pams = Object.assign(obj, parms)
                await this.PostListplayCode(pams)
              }
              let obj1 = {
                lengths: resp.data.data.items.length
              }
              parms = Object.assign(obj1, parms)
              await this.GetListUserId(parms);

            }

          }
        }

      })

    },
    // 查询计划状态
    async PostListplayCode(pams) {

      let nonce2 = Math.round(Math.random() * 100000000000)
      await this.$axios.post('api/openapi/v1/ad/campaign/pageInfo?access_token=' + pams.token + '&timestamp=' + this.time + '&nonce=' + nonce2 + '&advertiser_id=' + pams.adid[pams.a],
        {
          "ids": pams.ids,
        }).then(resps => {
        if (resps.data.data.list === undefined) {
          this.playCode.push({pauseState: 1})
        } else {
          this.playCode.push(resps.data.data.list[0])
        }
      })
    },
    //查询账号信息
    async GetListUserId(parms) {
      let nonce = Math.round(Math.random() * 100000000000)
      await this.$axios.get('api/openapi/v1/account/fetch?access_token=' + parms.token + '&timestamp=' + this.time + '&nonce=' + nonce + '&advertiser_id=' + parms.adid[parms.a])
        .then(async res => {
            if (res.data.message == '请求成功') {
              //测试
              if (this.value === "HOUR") {
                for (let e = 0; e < parms.lengths; e++) {
                  this.namedata.push(res.data.data)
                }
              } else {
                for (let e = 0; e < parms.lengths; e++) {
                  this.namedata.push(res.data.data)
                }
              }
            } else {

            }
          }
        )
    },
    //服务请求
    async TimeChangeto1() {
      //判断是哪个户
      this.sks = this.xiaobai[0]
      if (this.userUalue[1] === "mrqy") {
        for (let a = 0; a < this.mrqy.length; a++) {
          let parms = {
            a: a,
            startDate: this.value2.at(0),
            endDate: this.value2.at(1),
            summaryType: this.value,
            level: this.values,
            token: this.sks,
            adid: this.mrqy
          }
          await this.PostListQuery(parms)
        }
        this.temp = JSON.parse(JSON.stringify(this.datadata))
        this.temp1 = JSON.parse(JSON.stringify(this.namedata))
        this.temp3 = JSON.parse(JSON.stringify(this.playCode))
        for (let key = 0; key < this.temp.length; key++) {
          //h换名字
          this.ctrJson[0].nameid = this.temp1[key].name
          this.temp1[key].disGeneralBalance = this.temp1[key].disGeneralBalance / 100000
          this.temp2[key] = this.hb(this.temp1[key], this.temp[key])

          this.ctrJson[0].but = this.temp2[key].spent / this.temp2[key].clickCount
          this.ctrJson[0].but = parseFloat(this.ctrJson[0].but).toFixed(6);
          let tempVal3 = parseFloat(this.ctrJson[0].but).toFixed(5);
          this.ctrJson[0].but = tempVal3.substring(0, tempVal3.length - 1);
          this.ctrJson[0].CTR = this.temp2[key].clickCount / this.temp2[key].showCount
          this.ctrJson[0].CTR = parseFloat(this.ctrJson[0].CTR).toFixed(6);
          let tempVal = parseFloat(this.ctrJson[0].CTR).toFixed(5);
          this.ctrJson[0].CTR = tempVal.substring(0, tempVal.length - 1);
          this.ctrJson[0].CVR = this.temp2[key].addDesktopCount / this.temp2[key].clickCount
          this.ctrJson[0].CVR = parseFloat(this.ctrJson[0].CVR).toFixed(6);
          let tempVal1 = parseFloat(this.ctrJson[0].CVR).toFixed(5);
          this.ctrJson[0].CVR = tempVal1.substring(0, tempVal.length - 1);
          this.ctrJson[0].CLR = this.temp2[key].customRetainCount / this.temp2[key].formsubmitCount
          this.ctrJson[0].CLR = parseFloat(this.ctrJson[0].CLR).toFixed(6);
          let tempVal2 = parseFloat(this.ctrJson[0].CLR).toFixed(5);
          this.ctrJson[0].CLR = tempVal2.substring(0, tempVal.length - 1);
          this.ctrJson[0].zdycl = this.temp2[key].spent / this.temp2[key].customPayC;
          this.ctrJson[0].zdycl = parseFloat(this.ctrJson[0].zdycl).toFixed(6)
          let tempVal4 = parseFloat(this.ctrJson[0].zdycl).toFixed(5)
          this.ctrJson[0].zdycl = tempVal4.substring(0, tempVal4.length - 1);
          this.ctrJson[0].zdyff = this.temp2[key].spent / this.temp2[key].customPayCount;
          this.ctrJson[0].zdyff = parseFloat(this.ctrJson[0].zdyff).toFixed(6)
          let tempVal5 = parseFloat(this.ctrJson[0].zdyff).toFixed(5)
          this.ctrJson[0].zdyff = tempVal5.substring(0, tempVal5.length - 1);
          this.ctrJson[0].zdylh = this.temp2[key].spent / this.temp2[key].addDesktopCount;
          this.ctrJson[0].zdylh = parseFloat(this.ctrJson[0].zdylh).toFixed(6)
          let tempVal6 = parseFloat(this.ctrJson[0].zdylh).toFixed(5)
          this.ctrJson[0].zdylh = tempVal6.substring(0, tempVal6.length - 1);

          this.temp2[key] = this.hb(this.temp2[key], this.ctrJson[0])
          this.temp2[key] = this.hb(this.temp2[key], this.temp3[key])

        }
        this.temp2 = JSON.parse(JSON.stringify(this.temp2))
        this.datas = this.temp2
        this.isDisable = false

      }
      if (this.userUalue[1] === "qexs") {
        this.sks = this.xiaobai[1]
        for (let a = 0; a < this.qexs.length; a++) {
          let parms = {
            a: a,
            startDate: this.value2.at(0),
            endDate: this.value2.at(1),
            summaryType: this.value,
            level: this.values,
            token: this.sks,
            adid: this.qexs
          }
          await this.PostListQuery(parms)
        }
        this.temp = JSON.parse(JSON.stringify(this.datadata))
        this.temp1 = JSON.parse(JSON.stringify(this.namedata))
        this.temp3 = JSON.parse(JSON.stringify(this.playCode))
        for (let key = 0; key < this.temp.length; key++) {
          //h换名字
          this.ctrJson[0].nameid = this.temp1[key].name
          this.temp1[key].disGeneralBalance = this.temp1[key].disGeneralBalance / 100000
          this.temp2[key] = this.hb(this.temp1[key], this.temp[key])

          this.ctrJson[0].but = this.temp2[key].spent / this.temp2[key].clickCount
          this.ctrJson[0].but = parseFloat(this.ctrJson[0].but).toFixed(6);
          let tempVal3 = parseFloat(this.ctrJson[0].but).toFixed(5);
          this.ctrJson[0].but = tempVal3.substring(0, tempVal3.length - 1);
          this.ctrJson[0].CTR = this.temp2[key].clickCount / this.temp2[key].showCount
          this.ctrJson[0].CTR = parseFloat(this.ctrJson[0].CTR).toFixed(6);
          let tempVal = parseFloat(this.ctrJson[0].CTR).toFixed(5);
          this.ctrJson[0].CTR = tempVal.substring(0, tempVal.length - 1);
          this.ctrJson[0].CVR = this.temp2[key].addDesktopCount / this.temp2[key].clickCount
          this.ctrJson[0].CVR = parseFloat(this.ctrJson[0].CVR).toFixed(6);
          let tempVal1 = parseFloat(this.ctrJson[0].CVR).toFixed(5);
          this.ctrJson[0].CVR = tempVal1.substring(0, tempVal.length - 1);
          this.ctrJson[0].CLR = this.temp2[key].customRetainCount / this.temp2[key].formsubmitCount
          this.ctrJson[0].CLR = parseFloat(this.ctrJson[0].CLR).toFixed(6);
          let tempVal2 = parseFloat(this.ctrJson[0].CLR).toFixed(5);
          this.ctrJson[0].CLR = tempVal2.substring(0, tempVal.length - 1);
          this.ctrJson[0].zdycl = this.temp2[key].spent / this.temp2[key].customPayC;
          this.ctrJson[0].zdycl = parseFloat(this.ctrJson[0].zdycl).toFixed(6)
          let tempVal4 = parseFloat(this.ctrJson[0].zdycl).toFixed(5)
          this.ctrJson[0].zdycl = tempVal4.substring(0, tempVal4.length - 1);
          this.ctrJson[0].zdyff = this.temp2[key].spent / this.temp2[key].customPayCount;
          this.ctrJson[0].zdyff = parseFloat(this.ctrJson[0].zdyff).toFixed(6)
          let tempVal5 = parseFloat(this.ctrJson[0].zdyff).toFixed(5)
          this.ctrJson[0].zdyff = tempVal5.substring(0, tempVal5.length - 1);
          this.ctrJson[0].zdylh = this.temp2[key].spent / this.temp2[key].addDesktopCount;
          this.ctrJson[0].zdylh = parseFloat(this.ctrJson[0].zdylh).toFixed(6)
          let tempVal6 = parseFloat(this.ctrJson[0].zdylh).toFixed(5)
          this.ctrJson[0].zdylh = tempVal6.substring(0, tempVal6.length - 1);

          this.temp2[key] = this.hb(this.temp2[key], this.ctrJson[0])
          this.temp2[key] = this.hb(this.temp2[key], this.temp3[key])

        }
        this.temp2 = JSON.parse(JSON.stringify(this.temp2))
        this.datas = this.temp2
        this.isDisable = false

      }
      if (this.userUalue[1] === "dzff") {
        this.sks = this.xiaobai[2]
        for (let a = 0; a < this.dzff.length; a++) {
          let parms = {
            a: a,
            startDate: this.value2.at(0),
            endDate: this.value2.at(1),
            summaryType: this.value,
            level: this.values,
            token: this.sks,
            adid: this.dzff
          }
          await this.PostListQuery(parms)
        }
        this.temp = JSON.parse(JSON.stringify(this.datadata))
        this.temp1 = JSON.parse(JSON.stringify(this.namedata))
        this.temp3 = JSON.parse(JSON.stringify(this.playCode))
        for (let key = 0; key < this.temp.length; key++) {
          //h换名字
          this.ctrJson[0].nameid = this.temp1[key].name
          this.temp1[key].disGeneralBalance = this.temp1[key].disGeneralBalance / 100000
          this.temp2[key] = this.hb(this.temp1[key], this.temp[key])

          this.ctrJson[0].but = this.temp2[key].spent / this.temp2[key].clickCount
          this.ctrJson[0].but = parseFloat(this.ctrJson[0].but).toFixed(6);
          let tempVal3 = parseFloat(this.ctrJson[0].but).toFixed(5);
          this.ctrJson[0].but = tempVal3.substring(0, tempVal3.length - 1);
          this.ctrJson[0].CTR = this.temp2[key].clickCount / this.temp2[key].showCount
          this.ctrJson[0].CTR = parseFloat(this.ctrJson[0].CTR).toFixed(6);
          let tempVal = parseFloat(this.ctrJson[0].CTR).toFixed(5);
          this.ctrJson[0].CTR = tempVal.substring(0, tempVal.length - 1);
          this.ctrJson[0].CVR = this.temp2[key].addDesktopCount / this.temp2[key].clickCount
          this.ctrJson[0].CVR = parseFloat(this.ctrJson[0].CVR).toFixed(6);
          let tempVal1 = parseFloat(this.ctrJson[0].CVR).toFixed(5);
          this.ctrJson[0].CVR = tempVal1.substring(0, tempVal.length - 1);
          this.ctrJson[0].CLR = this.temp2[key].customRetainCount / this.temp2[key].formsubmitCount
          this.ctrJson[0].CLR = parseFloat(this.ctrJson[0].CLR).toFixed(6);
          let tempVal2 = parseFloat(this.ctrJson[0].CLR).toFixed(5);
          this.ctrJson[0].CLR = tempVal2.substring(0, tempVal.length - 1);
          this.ctrJson[0].zdycl = this.temp2[key].spent / this.temp2[key].customPayC;
          this.ctrJson[0].zdycl = parseFloat(this.ctrJson[0].zdycl).toFixed(6)
          let tempVal4 = parseFloat(this.ctrJson[0].zdycl).toFixed(5)
          this.ctrJson[0].zdycl = tempVal4.substring(0, tempVal4.length - 1);
          this.ctrJson[0].zdyff = this.temp2[key].spent / this.temp2[key].customPayCount;
          this.ctrJson[0].zdyff = parseFloat(this.ctrJson[0].zdyff).toFixed(6)
          let tempVal5 = parseFloat(this.ctrJson[0].zdyff).toFixed(5)
          this.ctrJson[0].zdyff = tempVal5.substring(0, tempVal5.length - 1);
          this.ctrJson[0].zdylh = this.temp2[key].spent / this.temp2[key].addDesktopCount;
          this.ctrJson[0].zdylh = parseFloat(this.ctrJson[0].zdylh).toFixed(6)
          let tempVal6 = parseFloat(this.ctrJson[0].zdylh).toFixed(5)
          this.ctrJson[0].zdylh = tempVal6.substring(0, tempVal6.length - 1);

          this.temp2[key] = this.hb(this.temp2[key], this.ctrJson[0])
          this.temp2[key] = this.hb(this.temp2[key], this.temp3[key])

        }
        this.temp2 = JSON.parse(JSON.stringify(this.temp2))
        this.datas = this.temp2
        this.isDisable = false

      }
    },

    async fetchHdCookieData() {
      const pageNum = 1;
      const uid = 1;
      const role = 1;
      const pageSize = 10;
      const name = ''; // 根据需要修改此参数
      const url = `https://control.zjwec.cn/api/hdcookie/page?pageNum=${pageNum}&uid=${uid}&role=${role}&pageSize=${pageSize}&name=${encodeURIComponent(name)}`;
      try {
        const response = await axios.get(url);
        console.log('数据获取成功:', response.data);
        this.AllCookieList = response.data.data.records;
        this.zjcookie = response.data.data.records[0].hdcookie
        this.$store.commit('updatescookile', response.data.data.records[0].hdcookie);

        // 这里可以处理返回的数据，例如更新到状态管理或组件
      } catch (error) {
        console.error('错误:', error);
      }
    },
    findCookieByName(targetName) {
      const record = this.AllCookieList.find(item => item.hdname === targetName);
      return record ? record.hdcookie : null;
    },
    async confimuuid(raw) {
      // 获取原始UUID字符串并拆行

      var lines = raw.split('\n');

      // 预处理UUID并去空行
      var uuids = [];
      for (var i = 0; i < lines.length; i++) {
        var line = lines[i].trim();
        if (line.length > 0) {
          uuids.push(line);
        }
      }

      if (uuids.length === 0) {
        return;
      }
      // 获取cookie
      if (this.cleanForm.hdname === '') {
        this.$message.error('请先选择一个区域');
        return;
      }
      var cookie = this.findCookieByName(this.cleanForm.hdname);
      // 创建请求数组
      var requests = [];
      for (var j = 0; j < uuids.length; j++) {
        var req = axios.get('https://control.zjwec.cn/api/bindzh/getUUid', {
          params: {
            keyword: uuids[j],
            cookie: cookie
          }
        });
        requests.push(req);
      }

      try {
        var responses = await Promise.all(requests);
        var uuidList = [];
        for (var k = 0; k < responses.length; k++) {
          var res = responses[k];
          // 安全地访问嵌套属性
          if (
            res &&
            res.data &&
            res.data.data &&
            res.data.data.length > 0 &&
            res.data.data[0].id
          ) {
            uuidList.push(res.data.data[0].id);
          }
        }

        console.log('最终UUID列表:', uuidList);
        return uuidList
      } catch (error) {
        console.error('批量请求出错:', error);
      }
    },
  },
  created() {
    this.fetchHdCookieData();

  },
}

</script>


































































































// WEBPACK FOOTER //
// src/components/batchUpdate.vue